{
	"dialog.ok": "OK",
	"dialog.cancel": "Zrušit",
	"dialog.confirm": "Potvrdit",
	"dialog.close": "Zavřít",
	"dialog.import": "Importovat",
	"dialog.save": "Uložit",
	"dialog.discard": "Zahodit",
	"dialog.dontshowagain": "Znovu nezobrazovat",
	"data.cube": "Kostka",
	"data.group": "Skupina",
	"data.texture": "Textura",
	"data.plugin": "Plugin",
	"data.preview": "Náhled",
	"data.toolbar": "Panel nástrojů",
	"data.image": "Obrázek",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Příkazový řádek [cmd]",
	"keys.delete": "Smazat",
	"keys.space": "Mezerník",
	"keys.leftclick": "Levé tlačítko",
	"keys.middleclick": "Stisk kolečka",
	"keys.rightclick": "Pravé tlačítko",
	"keys.tab": "Tab / Tabulátor",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Kontextová nabídka",
	"keys.left": "Šipka vlevo",
	"keys.up": "Šipka nahoru",
	"keys.right": "Šipka vpravo",
	"keys.down": "Šipka dolů",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Čárka",
	"keys.point": "Tečka",
	"keys.minus": "Mínus",
	"keys.cross": "Křížek",
	"keys.end": "Konec",
	"keys.pos1": "Pozice 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pozastavit",
	"message.rotation_limit.title": "Limity Rotace",
	"message.rotation_limit.message": "Rotace jsou v Minecraftu omezeny na jednu osu. Rotace na jiné ose vymaže všechny rotace na ostatních osách. Pokud modelujete pro jiné účely a potřebujete volné rotace, převeďte model na „Obecný model“.",
	"message.file_not_found.title": "Soubor Nebyl Nalezen",
	"message.file_not_found.message": "Blockbench nebyl schopen najít požadovaný soubor. Ujistěte se, že je soubor uložen na lokálním disku a ne na cloudovém úložišti.",
	"message.screenshot.title": "Snímek Modelu",
	"message.screenshot.clipboard": "Schránka",
	"message.screenshot.right_click": "Pravým kliknutím/podržením zkopírujte snímek modelu",
	"message.invalid_file.title": "Neplatný Soubor",
	"message.invalid_file.message": "Soubor JSON: %0 nelze otevřít",
	"message.invalid_model.title": "Neplatný Soubor s Modelem",
	"message.invalid_model.message": "Tento soubor neobsahuje platná data modelu.",
	"message.child_model_only.title": "Prázdný Podřízený Model",
	"message.child_model_only.message": "Tento soubor je doprovodný pro %0 a neobsahuje žádný model.",
	"message.unsaved_textures.title": "Neuložené Textury",
	"message.unsaved_textures.message": "Váš model má neuložené textury. Ujistěte se, zda je máte uložené a vložené ve správné složce vašeho resource packu.",
	"message.model_clipping.title": "Příliš Velký Model",
	"message.model_clipping.message": "Váš model obsahuje %0 kostek, které jsou větší než limit bloků povolený v Minecraftu. Tento model nebude v Minecraftu fungovat.",
	"message.loose_texture.title": "Přidání Textury",
	"message.loose_texture.message": "Přidaná textura není součástí žádného resource packu. Minecraft je schopen načíst textury pouze ze složky textures načteného resource packu.",
	"message.loose_texture.change": "Změnit Umístění",
	"message.update_res.title": "Rozlišení textury",
	"message.update_res.message": "Přejete si aktualizovat rozlišení projektu na rozlišení této textury? Pokud má vaše textura vyšší rozlišení než obvykle, klikněte na 'Zrušit'.",
	"message.update_res.update": "Aktualizovat",
	"message.bedrock_overwrite_error.message": "Blockbench není schopen zkombinovat tento model s daným starým souborem",
	"message.bedrock_overwrite_error.backup_overwrite": "Vytvořit zálohu a přepsat",
	"message.bedrock_overwrite_error.overwrite": "Přepsat",
	"message.close_warning.message": "Přejete si uložit váš model?",
	"message.close_warning.web": "Neuložená data budou ztracena. Opravdu chcete odejít?",
	"message.default_textures.title": "Výchozí textury",
	"message.default_textures.message": "Vyberte složku \"textures\" vašeho výchozího resource packu",
	"message.default_textures.detail": "Extrahujte výchozí resource pack z Minecraft .jar souboru, nebo Googlu a stáhněte jej. Poté najděte složku \"textures\" a otevřete ji. Blockbench si zapamatuje umístění složky a pokusí se z ní načíst textury, pokud je nemůže najít ve stávajícím resource packu.",
	"message.default_textures.select": "Vybrat výchozí \"textures\" složku",
	"message.image_editor.title": "Vyberte grafický editor",
	"message.image_editor.file": "Vybrat soubor...",
	"message.image_editor.exe": "Vyberte soubor .exe grafického editoru",
	"message.display_skin.title": "Minecraft skin",
	"message.display_skin.message": "Vyberte soubor skinu ve vašem počítači, nebo zadejte hráčské jméno",
	"message.display_skin.upload": "Vybrat soubor",
	"message.display_skin.reset": "Resetovat",
	"message.invalid_plugin": "Neplatný plugin, podívejte se do konzole",
	"message.load_plugin_app": "Přejete si povolit tomuto pluginu provádět změny na vašem počítači? Pro vyšší bezpečnost používejte doplňky od autorů, kterým důvěřujete.",
	"message.load_plugin_web": "Přejete si načíst tento Plugin? Pro vyšší bezpečnost používejte Pluginy od autorů, kterým důvěřujete.",
	"message.preset_no_info": "Předvolba neobsahuje informace pro tento slot",
	"message.restart_to_update": "Chcete-li použít nové změny, restartujte Blockbench",
	"message.save_file": "Uloženo jako %0",
	"dialog.project.title": "Projekt",
	"dialog.project.name": "Název souboru",
	"dialog.project.parent": "Nadřazený model",
	"dialog.project.geoname": "Identifikátor modelu",
	"dialog.project.ao": "Okolní okluze",
	"dialog.texture.title": "Textura",
	"dialog.texture.variable": "Variabilní",
	"dialog.texture.namespace": "Namespace",
	"dialog.texture.folder": "Složka",
	"dialog.extrude.title": "Vytlačit obrázek",
	"dialog.extrude.mode": "Režim skenování",
	"dialog.extrude.mode.areas": "Sféry",
	"dialog.extrude.mode.lines": "Linky",
	"dialog.extrude.mode.columns": "Sloupce",
	"dialog.extrude.mode.pixels": "Pixely",
	"dialog.extrude.opacity": "Minimální neprůhlednost",
	"dialog.extrude.scan": "Skenovat a nahrát",
	"dialog.display_preset.title": "Vytvořit přednastavení",
	"dialog.display_preset.message": "Vyberte sloty, které chcete uložit",
	"dialog.display_preset.create": "Vytvořit",
	"dialog.select.title": "Výběr",
	"dialog.select.group": "Ve vybrané skupině",
	"dialog.select.name": "Obsah jména",
	"dialog.select.random": "Náhodný",
	"dialog.select.select": "Vybrat",
	"dialog.scale.title": "Velikost modelu",
	"dialog.scale.axis": "Osa",
	"dialog.scale.clipping": "Oříznutí modelu: Váš model je pro plátno příliš velký",
	"dialog.scale.confirm": "Zvětšit",
	"dialog.plugins.title": "Pluginy",
	"dialog.plugins.installed": "Instalované",
	"dialog.plugins.available": "Dostupné",
	"dialog.plugins.install": "Instalovat",
	"dialog.plugins.uninstall": "Odinstalovat",
	"dialog.plugins.reload": "Znovu načíst",
	"dialog.plugins.none_installed": "Žádné instalované pluginy",
	"dialog.plugins.none_available": "Žádné dostupné pluginy",
	"dialog.plugins.web_only": "Pouze pro webovou aplikaci",
	"dialog.plugins.app_only": "Pouze pro stažený program",
	"dialog.plugins.author": "vyrobil %0",
	"dialog.create_texture.folder": "Složka",
	"dialog.create_texture.resolution": "Rozlišení",
	"dialog.input.title": "Vstup",
	"dialog.settings.settings": "Nastavení",
	"dialog.settings.keybinds": "Klávesové zkratky",
	"dialog.settings.about": "O aplikaci",
	"layout.color.back": "Zpět",
	"layout.color.back.desc": "Pozadí a pole pro vložení",
	"layout.color.dark": "Tmavý",
	"layout.color.dark.desc": "Pozadí plátna",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "Barva hlavního rozhraní",
	"layout.color.bright_ui": "Jasné UI",
	"layout.color.bright_ui.desc": "Kontextové nabídky a popisky",
	"layout.color.button": "Tlačítko",
	"layout.color.button.desc": "Tlačítka a spínače",
	"layout.color.selected": "Vybrané",
	"layout.color.selected.desc": "Vybrané záložky a objekty",
	"layout.color.border": "Okraj",
	"layout.color.border.desc": "Hranice tlačítek a vstupů",
	"layout.color.accent": "Zvýraznění",
	"layout.color.accent.desc": "Posuvník miniatury a další podrobnosti",
	"layout.color.grid": "Mřížka",
	"layout.color.grid.desc": "3D náhled mřížky",
	"layout.color.text": "Text",
	"layout.color.text.desc": "Běžný text",
	"layout.color.light": "Světlý",
	"layout.color.light.desc": "Zdůrazněný text",
	"layout.color.accent_text": "Zvýrazněný text",
	"layout.color.accent_text.desc": "Text na zvýrazněném pozadí",
	"layout.font.main": "Hlavní font",
	"layout.font.headline": "Font nadpisu",
	"about.version": "Verze:",
	"settings.category.general": "Všeobecné",
	"settings.category.preview": "Přehled",
	"settings.category.grid": "Mřížka",
	"settings.category.edit": "Editace",
	"settings.category.snapping": "Přichytávání",
	"settings.category.defaults": "Výchozí nastavení",
	"settings.category.dialogs": "Dialogy",
	"settings.category.export": "Export",
	"settings.language": "Jazyk",
	"settings.language.desc": "Jazyk rozhraní",
	"settings.backup_interval": "Interval zálohování",
	"settings.backup_interval.desc": "Interval automatických záloh v minutách",
	"settings.origin_size": "Zvýraznění bodu otáčení",
	"settings.origin_size.desc": "Velikost značky bodu otáčení",
	"settings.control_size": "Velikost ovládacího prvku osy",
	"settings.control_size.desc": "Velikost tříosového kontrolního nástroje",
	"settings.display_skin": "Zobrazení skinu",
	"settings.display_skin.desc": "Vzhled použitý pro model hráče v Zobrazení",
	"settings.shading": "Stínování",
	"settings.shading.desc": "Povolit stínování",
	"settings.base_grid": "Malá Mřížma",
	"settings.base_grid.desc": "Zobrazit malou mřížku a osy",
	"settings.large_grid": "Bloková mřížka",
	"settings.large_grid.desc": "Zobrazit 16x16 blokovou mřížku",
	"settings.full_grid": "Upřesnit blokovou mřížku",
	"settings.full_grid.desc": "Zobrazit blokovou mřížku s přesností na pixely",
	"settings.large_box": "Velký box",
	"settings.large_box.desc": "Zobrazit 3x3 hranice bloku",
	"settings.display_grid": "Režim zobrazení",
	"settings.display_grid.desc": "Zobrazit mřížku v režimu zobrazení",
	"settings.undo_limit": "Limit navrácení",
	"settings.undo_limit.desc": "Počet kroků, které můžete navrátit zpět",
	"settings.local_move": "Pohyb po relativních osách",
	"settings.local_move.desc": "Pohyb rotovaných prvků po jejich vlastních osách (pokud je to možné)",
	"settings.canvas_unselect": "Zrušit výběr kliknutím do pozadí",
	"settings.canvas_unselect.desc": "Zruší výběr kliknutím do pozadí",
	"settings.paint_side_restrict": "Omezit štětec na stranu",
	"settings.paint_side_restrict.desc": "Omezí štětce tak, aby maloval pouze na aktuální straně",
	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Povolit Auto UV jako výchozí",
	"settings.create_rename": "Přejmenovat Nový Prvek",
	"settings.create_rename.desc": "Pojmenování podle zaměření při vytváření nového prvku nebo skupiny",
	"settings.edit_size": "Rozlišení mřížky",
	"settings.edit_size.desc": "Rozlišení mřížky, ke které se prvky přichytávají",
	"settings.shift_size": "Rozlišení shift klávesnice",
	"settings.shift_size.desc": "Rozlišení mřížky při držení klávesnice shift",
	"settings.ctrl_size": "Rozlišení ctrl klávesnice",
	"settings.ctrl_size.desc": "Rozlišení mřížky při držení klávesnice ctrl",
	"settings.negative_size": "Záporné velikosti",
	"settings.negative_size.desc": "Povolí nástroji pro změnu velikosti použít záporné velikosti",
	"settings.minifiedout": "Řádkový export",
	"settings.minifiedout.desc": "Zapsat JSON soubory do jednoho řádku",
	"settings.export_groups": "Exportovat skupiny",
	"settings.export_groups.desc": "Uloží skupiny v blokových, nebo předmětových modelových souborech",
	"settings.credit": "Záslužný komentář",
	"settings.credit.desc": "Pro přidání záslužného komentáře exportovaným souborům",
	"settings.default_path": "Výchozí výběr MC textur",
	"settings.default_path.desc": "Složka, ze které Blockbench načítá výchozí textury",
	"settings.image_editor": "Obrázkový editor",
	"settings.image_editor.desc": "Výchozí obrázkový editor pro úpravu textur",
	"category.navigate": "Navigace",
	"category.tools": "Nástroje",
	"category.file": "Složka",
	"category.blockbench": "Blockbench",
	"category.edit": "Úpravy",
	"category.transform": "Transformace",
	"category.view": "Pohled",
	"category.display": "Nastavení zobrazení",
	"category.textures": "Textury",
	"category.misc": "Další",
	"keybind.preview_select": "Vybrat",
	"keybind.preview_rotate": "Otočení pohledu",
	"keybind.preview_drag": "Tažení pohledu",
	"keybind.confirm": "Potvrdit",
	"keybind.cancel": "Zrušit",
	"action.slider_inflate": "Zvětšit",
	"action.slider_inflate.desc": "Zvětší kostky ve všech směrech bez změny UV.",
	"action.slider_brush_size": "Velikost",
	"action.slider_brush_size.desc": "Poloměr štětce v pixelech",
	"action.slider_brush_opacity": "Průhlednost",
	"action.slider_brush_opacity.desc": "Průhlednost štětce v procentech",
	"action.slider_brush_softness": "Měkkost",
	"action.slider_brush_softness.desc": "Měkkost štětce v procentech",
	"action.uv_slider_pos_x": "Vodorovný posun",
	"action.uv_slider_pos_x.desc": "Posune výběr UV vodorovně všech vybraných kostek",
	"action.uv_slider_pos_y": "Svislý posun",
	"action.uv_slider_pos_y.desc": "Posune výběr UV svisle všech vybraných kostek",
	"action.uv_slider_size_x": "Vodorovné měřítko",
	"action.uv_slider_size_x.desc": "Nastaví měřítko UV výběru vodorovně u všech vybraných kostek",
	"action.uv_slider_size_y": "Svislé měřítko",
	"action.uv_slider_size_y.desc": "Nastaví měřítko UV výběru svisle u všech vybraných kostek",
	"action.vertex_snap_mode": "Režim přichycení",
	"action.vertex_snap_mode.desc": "Vyberte, zda funkce Přichytávání k vrcholu přesune prvky na vybranou pozici, nebo je změní na požadovanou velikost",
	"action.move_tool": "Posunout",
	"action.move_tool.desc": "Nástroj pro výběr a posun prvků",
	"action.resize_tool": "Změnit velikost",
	"action.resize_tool.desc": "Nástroj pro výběr a změnu velikosti prvků",
	"action.brush_tool": "Malovací štětec",
	"action.brush_tool.desc": "Nástroj pro malování na bitmapových texturách, na površích nebo v UV editoru",
	"action.vertex_snap_tool": "Vrcholové přichycení",
	"action.vertex_snap_tool.desc": "Pro přesun jedné krychle ke druhé krychli spojením dvou vrcholů",
	"action.swap_tools": "Přepnutí nástrojů",
	"action.swap_tools.desc": "Přepínání mezi nástrojem pro přesun a změnu velikosti",
	"action.project_window": "Projekt...",
	"action.project_window.desc": "Otevře okno projektu, kde můžete upravit metadata svého modelu",
	"action.open_model": "Otevřít model",
	"action.open_model.desc": "Otevře soubor s modelem na vašem počítači",
	"action.extrude_texture": "Extrudovaná textura",
	"action.extrude_texture.desc": "Vytvoří model roztažením textury",
	"action.export_blockmodel": "Exportovat Blokový/Předmětový Model",
	"action.export_blockmodel.desc": "Exportuje blokový, nebo předmětový model typu Minecraft Java Edice",
	"action.export_optifine_part": "Exportovat Částečný OptiFine Model",
	"action.export_optifine_part.desc": "Exportuje samostatnou část pro OptiFine Model Entity",
	"action.export_optifine_full": "Exportovat OptiFine soubor typu .jem",
	"action.export_optifine_full.desc": "Export a full OptiFine entity model",
	"action.export_obj": "Exportovat jako model typu .obj",
	"action.export_obj.desc": "Export a Wavefront OBJ model for rendering",
	"action.settings_window": "Nastavení...",
	"action.settings_window.desc": "Otevře dialog nastavení programu Blockbench.",
	"action.plugins_window": "Doplňky...",
	"action.plugins_window.desc": "Otevře okno úložiště doplňků",
	"action.reset_layout": "Resetovat Rozvržení",
	"action.reset_layout.desc": "Resetuje rozvržení do výchozího nastavení programu Blockbench",
	"action.load_plugin": "Načíst Doplněk ze Souboru",
	"action.load_plugin.desc": "Pro načtení doplňku pomocí nahrání zdrojového souboru",
	"action.reload_plugins": "Znovu Načíst Doplňky",
	"action.reload_plugins.desc": "Znovu načtěte všechny vývojové doplňky",
	"action.undo": "Vrátit Zpět",
	"action.undo.desc": "Vrácení se zpět před poslední provedenou změnu",
	"action.redo": "Navrátit Zpět",
	"action.redo.desc": "Vrátí zpět po použití 'Vrátit Zpět'",
	"action.copy": "Kopírovat",
	"action.copy.desc": "Zkopíruje vybraný výběr, plochu, nebo nastavení zobrazení",
	"action.paste": "Vložit",
	"action.paste.desc": "Vloží poslední vybraný výběr, plochu, nebo nastavení zobrazení",
	"action.cut": "Oříznutí",
	"action.cut.desc": "Ořízne vybraný výběr, plochu, nebo nastavení zobrazení",
	"action.add_cube": "Přidat Kostku",
	"action.add_cube.desc": "Přidá novou Kostku",
	"action.add_group": "Přidat Skupinu",
	"action.add_group.desc": "Přidá novou skupinu, nebo část těla",
	"action.outliner_toggle": "Přepnout Na Více Možností",
	"action.outliner_toggle.desc": "Přepíná spínače pro více možností v seznamu kostek",
	"action.duplicate": "Zdvojit",
	"action.delete": "Vymazat",
	"action.sort_outliner": "Roztřídit Seznam Kostek",
	"action.sort_outliner.desc": "Roztřídí seznam kostek podle abecedního pořadí",
	"action.select_window": "Vybrat...",
	"action.select_window.desc": "Vyhledá a vybere prvky na základě jejich vlastností",
	"action.invert_selection": "Převrátit Výběr",
	"action.invert_selection.desc": "Převrátí aktuální výběr prvků",
	"action.select_all": "Vybrat Vše",
	"action.collapse_groups": "Sbalit Skupiny",
	"action.collapse_groups.desc": "Sbalí všechny skupiny",
	"action.scale": "Měřítko...",
	"action.scale.desc": "Změnit velikost vybraných prvků",
	"action.toggle_visibility": "Přepnout Viditelnost",
	"action.toggle_visibility.desc": "Přepne viditelnost vybraných prvků",
	"action.toggle_export": "Přepnout Export",
	"action.toggle_export.desc": "Přepne nastavení exportu vybraných prvků",
	"action.toggle_autouv": "Přepnout Automatické UV",
	"action.toggle_autouv.desc": "Přepne automatické nastavení UV vybraných prvků",
	"action.toggle_shade": "Přepnout Stínování",
	"action.toggle_shade.desc": "Přepne stínování vybraných kostek",
	"action.rename": "Přejmenovat",
	"action.rename.desc": "Změní název vybraných prvků nebo skupiny",
	"action.add_display_preset": "Nové Přednastavení",
	"action.add_display_preset.desc": "Přidat nové zobrazovací přednastavení",
	"action.fullscreen": "Celá Obrazovka",
	"action.fullscreen.desc": "Přepíná režim celé obrazovky",
	"action.zoom_in": "Přiblížit",
	"action.zoom_in.desc": "Přiblížení pro zvětšení rozhraní",
	"action.zoom_out": "Oddálit",
	"action.zoom_out.desc": "Oddálení pro zmenšení rozhraní",
	"action.zoom_reset": "Resetovat Přiblížení",
	"action.zoom_reset.desc": "Resetuje přiblížení na výchozích 100%",
	"action.reset_interface": "Resetovat Rozhraní",
	"action.reset_interface.desc": "Resetuje velikost a pozici GUI",
	"action.screenshot_model": "Snímek Modelu",
	"action.screenshot_model.desc": "Pořídí oříznutý snímek modelu ze současného úhlu pohledu",
	"action.screenshot_app": "Snímek Aplikace",
	"action.screenshot_app.desc": "Pořídí snímek celého okna aplikace",
	"action.import_texture": "Vložit Texturu",
	"action.import_texture.desc": "Vloží jednu nebo více textur ze systému souborů",
	"action.create_texture": "Vytvořit Texturu",
	"action.create_texture.desc": "Vytvoří prázdnou texturu nebo texturovou šablonu",
	"action.save_textures": "Uložit Textury",
	"action.save_textures.desc": "Uloží všechny neuložené textury",
	"action.animated_textures": "Přehrát Animaci Textur",
	"action.animated_textures.desc": "Spustí a zastaví předzobrazení animovaných textur",
	"action.origin_to_geometry": "Centrovat otočný bod",
	"action.origin_to_geometry.desc": "Nastaví bod otáčení do středu výběru",
	"action.bone_reset_toggle": "Resetovat Část Těla",
	"action.bone_reset_toggle.desc": "Zastaví část těla od zobrazování kostek z nadřazeného modelu",
	"action.reload": "Znovu NaČíst Blockbench",
	"action.reload.desc": "Znovu načte Blockbench. Tato akce smaže všechny neuložené změny",
	"menu.file": "Soubor",
	"menu.edit": "Upravit",
	"menu.transform": "Přeměnit",
	"menu.display": "Zobrazení",
	"menu.view": "Pohled",
	"menu.file.new": "Nový Soubor",
	"menu.file.recent": "Nedávné Soubory",
	"menu.file.import": "Nahrát",
	"menu.file.export": "Exportovat",
	"menu.transform.rotate": "Otočit",
	"menu.transform.flip": "Přehodit",
	"menu.transform.center": "Střed",
	"menu.transform.properties": "Vlastnosti",
	"menu.display.preset": "Použít Přednastavení",
	"menu.display.preset_all": "Použít Všude Přednastavení",
	"menu.display.remove_preset": "Odstranit Přednastavení",
	"menu.view.zoom": "Přiblížení",
	"menu.view.background": "Pozadí",
	"menu.view.screenshot": "Snímek",
	"menu.cube.color": "Barva Značky",
	"menu.cube.texture": "Textura",
	"menu.cube.texture.transparent": "Transparentní",
	"menu.cube.texture.blank": "Prázdný",
	"menu.group.sort": "Třídit",
	"menu.texture.face": "Aplikovat na Plochu",
	"menu.texture.file": "Soubor",
	"menu.texture.refresh": "Aktualizovat Zobrazení",
	"menu.texture.change": "Změnit Soubor",
	"menu.texture.folder": "Otevřít ve Složce",
	"menu.texture.edit": "Edit",
	"menu.texture.export": "Uložit Jako",
	"menu.texture.save": "Uložit",
	"menu.texture.properties": "Nastavení...",
	"menu.preview.background": "Pozadí",
	"menu.preview.background.load": "Nahrát",
	"menu.preview.background.position": "Pozice",
	"menu.preview.background.lock": "Zamknout ke Kameře",
	"menu.preview.screenshot": "Snímek",
	"menu.preview.perspective": "Perspektiva",
	"menu.preview.perspective.normal": "Normální",
	"menu.preview.quadview": "Čtyři zobrazení",
	"menu.preview.stop_drag": "Zastavit Polohování Pozadí",
	"menu.uv.mapping.rotation": "Rotace",
	"menu.uv.texture": "Textura",
	"cube.color.light_blue": "Světlá Modrá",
	"cube.color.yellow": "Žlutá",
	"cube.color.orange": "Oranžová",
	"cube.color.red": "Červená",
	"cube.color.purple": "Fialová",
	"cube.color.blue": "Modrá",
	"cube.color.green": "Zelená",
	"cube.color.lime": "Světle Zelená",
	"switches.visibility": "Viditelnost",
	"switches.export": "Exportovat",
	"switches.autouv": "Automatické UV",
	"panel.uv": "UV",
	"panel.display": "Zobrazení",
	"panel.textures": "Textury",
	"panel.outliner": "Seznam Kostek",
	"uv_editor.title": "UV Editor",
	"uv_editor.all_faces": "Všechny plochy",
	"uv_editor.no_faces": "Žádný",
	"face.north": "Sever",
	"face.south": "Jih",
	"face.west": "Západ",
	"face.east": "Východ",
	"face.up": "Horní Plocha",
	"face.down": "Dolní Plocha",
	"direction.north": "Sever",
	"direction.south": "Jih",
	"direction.west": "Západ",
	"direction.east": "Východ",
	"direction.top": "Nahoru",
	"direction.bottom": "Dolů",
	"display.slot.third_right": "Pohled z třetí osoby [pravá ruka]",
	"display.slot.third_left": "Pohled z třetí osoby [levá ruka]",
	"display.slot.first_right": "Pohled z první osoby [pravá ruka]",
	"display.slot.first_left": "Pohled z první osoby [levá ruka]",
	"display.slot.head": "Hlava",
	"display.slot.ground": "Zobrazení na Zemi",
	"display.slot.frame": "Rámeček",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotace",
	"display.translation": "Posunutí",
	"display.scale": "Měřítko",
	"display.slot": "Slot",
	"display.reference": "Referenční Model",
	"display.reference.player": "Hráč",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Stojan na brnění",
	"display.reference.baby_zombie": "Malý Zombie",
	"display.reference.armor_stand_small": "Malý stojan na brnění",
	"display.reference.monitor": "Normální",
	"display.reference.bow": "Luk",
	"display.reference.block": "Blok",
	"display.reference.frame": "Rámeček na Předměty",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventář",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Zadejte prosím jméno",
	"display.preset.item": "Výchozí Předmět",
	"display.preset.block": "Výchozí Blok",
	"display.preset.handheld": "Výchozí Zbraň",
	"display.preset.rod": "Výchozí Tyč",
	"dialog.continue": "Pokračovat",
	"message.square_textures": "Textury musí být čtvercové",
	"message.unsaved_texture.title": "Neuložená textura",
	"message.unsaved_texture.message": "Všechny neuložené změny této textury budou ztraceny. Chcete pokračovat?",
	"action.vertex_snap_mode.move": "Posunout",
	"action.vertex_snap_mode.scale": "Měřítko",
	"action.open_model_folder": "Otevřít Složku s Modelem",
	"action.open_model_folder.desc": "Otevře složku, ve které je model uložen",
	"action.change_textures_folder": "Změnit Umístění Textury",
	"action.change_textures_folder.desc": "Pro změnu složky, kde jsou všechny textury uložené",
	"menu.texture.particle": "Použít pro Částice",
	"message.update_notification.title": "Aktualizaci se nepodařilo nainstalovat",
	"message.update_notification.message": "K dispozici je nová verze Blockbench. Chcete-li provést aktualizaci, povolte v nastavení Automatické aktualizace!",
	"message.untextured": "Tato plocha neobsahuje texturu",
	"dialog.toolbar_edit.title": "Přizpůsobení panelu nástrojů",
	"keybindings.reset": "Obnovit původní",
	"keybindings.clear": "Prázdné",
	"action.cube_counter": "Počitatel Kostek",
	"action.uv_rotation": "UV Rotace",
	"action.uv_rotation.desc": "Rotace UV plochy",
	"action.uv_grid": "UV Mřížka",
	"action.uv_grid.desc": "Rozlišení mřížky, ke které se UV selector přichytí",
	"action.uv_grid.auto": "Automaticky",
	"action.uv_maximize": "Maximalizovat UV",
	"action.uv_maximize.desc": "Nastaví UV této plochy na plnou velikost textury",
	"action.uv_auto": "Automatické UV",
	"action.uv_auto.desc": "Nastaví UV velikost této plochy na její skutečnou velikost",
	"action.uv_rel_auto": "Relativní automatické UV",
	"action.uv_rel_auto.desc": "Nastaví UV této plochy do polohy a velikosti skutečné plochy",
	"action.uv_mirror_x": "UV Zrcadlo X",
	"action.uv_mirror_x.desc": "Zrcadlí UV této plochy na ose X",
	"action.uv_mirror_y": "UV Zrcadlo Y",
	"action.uv_mirror_y.desc": "Zrcadlí UV této plochy na ose Y",
	"action.uv_transparent": "Průhledná Plocha",
	"action.uv_transparent.desc": "Zprůhlední danou plochu",
	"action.uv_reset": "Resetovat Plochu",
	"action.uv_reset.desc": "Resetuje danou plochu",
	"action.cullface": "Dotykové vynechání",
	"action.cullface.desc": "Znemožní načtení textury pro tuto plochu, pokud je vybranná strana modelu zakryta",
	"action.auto_cullface": "Automatické Dotykové vynechání",
	"action.auto_cullface.desc": "Nastaví na sebe Dotykové vynechání pro tuto plochu",
	"action.face_tint": "Odstín Barvy",
	"action.face_tint.desc": "Povolí možností odstínu pro danou plochu",
	"menu.toolbar.edit": "Upravit",
	"menu.toolbar.reset": "Restovat",
	"uv_editor.rotated": "Otočeno",
	"uv_editor.auto_cull": "Automatické Dotykové vynechání",
	"uv_editor.copied": "Plocha Zkopírována",
	"uv_editor.pasted": "Plocha Vložena",
	"uv_editor.copied_x": "Zkopírováno %0 Ploch",
	"uv_editor.reset": "Resetovat Plochu",
	"uv_editor.maximized": "Maximalizováno",
	"uv_editor.autouv": "Automatická (Reálná) Velikost",
	"uv_editor.mirrored": "Zrcadlení",
	"uv_editor.to_all": "Aplikováno na Všechny Plochy",
	"uv_editor.transparent": "Nastaveno jako Průhledné",
	"uv_editor.cullface_on": "Dotykové vynechání Zapnuto",
	"uv_editor.cullface_off": "Dotykové vynechání Vypnuto",
	"uv_editor.tint_on": "Odstínový Nádech Zapnut",
	"uv_editor.tint_off": "Odstínový Nádech Vypnut",
	"action.uv_apply_all": "Aplikovat na Všech Plochách",
	"action.uv_apply_all.desc": "Použije nastavení aktuální plochy na všechny plochy",
	"message.image_editor_missing.title": "Výchozí obrázkový editor",
	"message.image_editor_missing.message": "Vyberte spustitelný soubor vašeho obrázkového editoru.",
	"message.image_editor_missing.detail": "Blockbench nebyl schopen najít na vašem počítači obrázkový editor. Vyberte prosím spustitelný soubor vašeho preferovaného obrázkového editoru.",
	"action.update_autouv": "Aktualizovat Automatické UV",
	"action.update_autouv.desc": "Aktualizuje automatické UV mapování vybraných kostek",
	"category.uv": "UV",
	"status_bar.saved": "Model je uložen",
	"status_bar.unsaved": "Máte neuložené změny",
	"action.move_up": "Posunout Nahoru",
	"action.move_up.desc": "Posune vybrané prvky nahoru vzhledem k aktuálnímu úhlu kamery",
	"action.move_down": "Posunout Dolů",
	"action.move_down.desc": "Posune vybrané prvky dolů vzhledem k aktuálnímu úhlu kamery",
	"action.move_left": "Posunout Vlevo",
	"action.move_left.desc": "Posune vybrané prvky vlevo vzhledem k aktuálnímu úhlu kamery",
	"action.move_right": "Posunout Vpravo",
	"action.move_right.desc": "Posune vybrané prvky vpravo vzhledem k aktuálnímu úhlu kamery",
	"action.move_forth": "Posunout Dopředu",
	"action.move_forth.desc": "Posune vybrané prvky dopředu vzhledem k aktuálnímu úhlu kamery",
	"action.move_back": "Posunout Dozadu",
	"action.move_back.desc": "Posune vybrané prvky dozadu vzhledem k aktuálnímu úhlu kamery",
	"layout.color.wireframe": "Drátový Rám",
	"layout.color.wireframe.desc": "Drátový Rám - Zobrazit linky",
	"layout.color.wireframe_selectable": "Vybratelný drátěný model",
	"layout.color.wireframe_selectable.desc": "Nevybrané hrany a vrcholy aktivní sítě v editačním režimu",
	"action.add_animation": "Přidat Animaci",
	"action.add_animation.desc": "Vytvoří prázdnou animaci",
	"action.load_animation_file": "Vložit Animaci",
	"action.load_animation_file.desc": "Pro vložení souboru s animací",
	"action.play_animation": "Přehrát Animaci",
	"action.play_animation.desc": "Předzobrazení vybrané animaci",
	"action.slider_keyframe_time": "Časový Kód",
	"action.slider_keyframe_time.desc": "Změna časových kódů u vybraných klíčových snímků",
	"timeline.rotation": "Rotace",
	"timeline.position": "Pozice",
	"timeline.scale": "Měřítko",
	"menu.keyframe.quaternion": "Kvaternion",
	"panel.animations": "Animace",
	"panel.keyframe": "Snímek",
	"panel.keyframe.type": "Snímek (%0)",
	"generic.delete": "Smazat",
	"generic.rename": "Přejmenovat",
	"message.no_animation_selected": "Musíte vybrat animaci, abyste mohli pokračovat",
	"message.no_bone_selected": "Musíte vybrat část těla, abyste mohli pokračovat",
	"message.duplicate_groups.title": "Rozdvojit název části těla",
	"message.duplicate_groups.message": "Název této části těla již existuje na více částech. To může způsobovat problémy.",
	"action.delete_keyframes": "Smazat Snímky",
	"action.delete_keyframes.desc": "Vymaže všechny vybrané snímky",
	"menu.animation": "Animace",
	"menu.animation.loop": "Opakovací Režim",
	"menu.animation.override": "Přepsat",
	"menu.animation.anim_time_update": "Proměnná Aktualizace Času Animace",
	"message.display_skin_model.title": "Model skinu",
	"message.display_skin_model.message": "Zvolte si typ modelu vašeho skinu",
	"message.display_skin_model.classic": "Klasický",
	"message.display_skin_model.slim": "Hubený",
	"message.bone_material": "Změnit materiál části těla",
	"action.slider_animation_length": "Délka Trvání Animace",
	"action.slider_animation_length.desc": "Pro změnu délky trvání vybrané animace",
	"panel.variable_placeholders": "Variabilní Zástupné Symboly",
	"panel.variable_placeholders.info": "Seznam variabilit, které chcete pro náhled přes jméno=hotnota",
	"status_bar.vertex_distance": "Vzdálenost: %0",
	"dialog.create_gif.title": "Natočit GIF",
	"dialog.create_gif.length": "Délka",
	"dialog.create_gif.fps": "Snímková frekvence FPS",
	"dialog.create_gif.play": "Spustit animaci",
	"category.animation": "Animace",
	"action.record_model_gif": "Natočit GIF",
	"action.record_model_gif.desc": "Natočí animovaný GIF modelu ze současného úhlu pohledu",
	"display.mirror": "Zrcadlo",
	"data.separator": "Separátor",
	"menu.preview.background.set_position": "Natavit Pozici",
	"dialog.toolbar_edit.hidden": "Schované",
	"action.export_class_entity": "Exportovat Entitu Typu Java",
	"action.export_class_entity.desc": "Exportuje model entity do stylu Java",
	"settings.seethrough_outline": "Rentgenové obrysy",
	"settings.seethrough_outline.desc": "Zobrazit obrysů skrze objekty",
	"mode.edit": "Editor",
	"mode.paint": "Kreslení",
	"mode.display": "Zobrazení",
	"mode.animate": "Animace",
	"status_bar.recording_gif": "Nahrávání souboru GIF",
	"status_bar.processing_gif": "Zpracovávání souboru GIF",
	"settings.backup_retain": "Doba Uchování Zálohy",
	"settings.backup_retain.desc": "Nastaví, jak dlouho má program uchovávat zálohy. Udáváno ve dnech",
	"action.rotate_tool": "Otočit",
	"action.rotate_tool.desc": "Nástroj pro výběr a otáčení prvků",
	"action.fill_tool": "Výplň Barvou",
	"action.fill_tool.desc": "Pro vyplnění celé plochy jedinou barvou",
	"action.eraser": "Guma",
	"action.eraser.desc": "Gumovací nástroj pro změnu barev na textuře na průhlednou",
	"action.color_picker": "Sběrač Barvy",
	"action.color_picker.desc": "Nástroj pro vybrání barvy z pixelů na vaší textuře",
	"switches.mirror": "Zrcadlové UV",
	"language_name": "Čeština",
	"message.plugin_reload": "Znovu načteno %0 lokálních doplňků",
	"settings.brightness": "Jas",
	"settings.brightness.desc": "Jas náhledu. Výchozí hodnota je 50",
	"menu.preview.perspective.reset": "Resetovat Kameru",
	"action.fill_mode": "Režim Vyplnění",
	"action.fill_mode.face": "Plocha",
	"action.fill_mode.color": "Barvy",
	"action.toggle_mirror_uv": "UV Zrcadlení",
	"action.toggle_mirror_uv.desc": "Přepne UV zrcadlení vybraných kostek na ose X",
	"menu.texture.blank": "Aplikovat na Plochy bez Textury",
	"dialog.scale.select_overflow": "Vybrat přebytečné",
	"action.action_control": "Ovládání Akce",
	"action.action_control.desc": "Pro vyhledání a provedení všech dostupných akcí",
	"keybindings.recording": "Nahrávání klávesy",
	"keybindings.press": "Stisknutím klávesy, kombinace kláves nebo klikem kdekoli na obrazovce zaznamenáte klávesovou zkratku.",
	"action.pivot_tool": "Nástroj pro otáčení",
	"action.pivot_tool.desc": "Nástroj pro změnu bodu otáčení prvků a částí těla",
	"action.slider_animation_speed": "Rychlost Přehrávání",
	"action.slider_animation_speed.desc": "Rychlost přehrávání na časové lince v procentech",
	"action.previous_keyframe": "Předchozí Snímek",
	"action.previous_keyframe.desc": "Přeskočí na předchozí snímek",
	"action.next_keyframe": "Další Snímek",
	"action.next_keyframe.desc": "Přeskočí na další snímek",
	"message.outdated_client.title": "Starší verze",
	"message.outdated_client.message": "Prosím, přejděte na nejnovější verzi programu Blockbench, abyste mohli použít tuto funkci.",
	"action.export_asset_archive": "Stáhnout Archiv",
	"action.export_asset_archive.desc": "Pro stažení archivu s modelem a všemi texturami v něm",
	"action.upload_sketchfab": "Nahrání Na Sketchfab",
	"message.sketchfab.name_or_token": "Vložte prosím váš Sketchfab token a jméno",
	"dialog.sketchfab_uploader.title": "Nahrání Sketchfab Modelu",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "Token se používá pro propojení Blockbenche s vaším Sketchfab účtem. Naleznete ho na %0",
	"dialog.sketchfab_uploader.name": "Název Modelu",
	"dialog.sketchfab_uploader.description": "Popis",
	"dialog.sketchfab_uploader.tags": "Tagy",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "Token pro autorizaci programu Blockbench pro umožnění nahrávání na váš Sketchfab účet",
	"panel.color": "Barva",
	"data.origin": "Osa otáčení",
	"message.sketchfab.success": "Model úspěšně nahrán",
	"message.sketchfab.error": "Nepodařilo se nahrát model do Sketchfab",
	"settings.outliner_colors": "Obrysové barvy",
	"settings.outliner_colors.desc": "Zobrazit barvy prvků a skupin v přehledu",
	"action.upload_sketchfab.desc": "Nahraje model na Sketchfab",
	"action.element_colors": "Barvy Kostek",
	"action.element_colors.desc": "Zobrazí barvy kostek na jejich seznamu",
	"texture.error.file": "Soubor nelze najít",
	"texture.error.parent": "Soubor s texturou poskytován nadřízeným modelem",
	"message.recover_backup.title": "Obnovit model",
	"message.recover_backup.message": "Blockbench byl zavřen bez uložení. Přejete si obnovit neuložený model?",
	"message.invalid_session.title": "Neplatný token relace",
	"message.invalid_session.message": "Relace, ke které se pokoušíte připojit, vypršela, nebo je zadaný token neplatný.",
	"dialog.create_texture.power": "Velikost síly 2",
	"dialog.create_gif.turn": "Rychlost točny",
	"action.edit_session": "Upravit Relaci...",
	"action.edit_session.desc": "Připojí se k upravovací relaci pro interakci s dalšími uživateli",
	"action.reset_keyframe": "Resetovat Snímek",
	"action.reset_keyframe.desc": "Resetujte všechny hodnoty vybraných klíčových snímků",
	"dialog.edit_session.title": "Úprava Relace",
	"edit_session.username": "Uživatelské Jméno",
	"edit_session.token": "Token",
	"edit_session.about": "Úprava relace může být použita pro spolupráci na modelech pomocí Internetu. Vytvořte relaci, zkopírujte token a pošlete ho svým spolupracovníkům, kteří ho mohou použít pro připojení.",
	"edit_session.join": "Připojit k Relaci",
	"edit_session.create": "Vytvořit Relaci",
	"edit_session.quit": "Opustit Relaci",
	"edit_session.joined": "%0 se připojil k relaci",
	"edit_session.left": "%0 opustil relaci",
	"edit_session.quit_session": "Opustil stávající relaci",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hosting",
	"edit_session.connected": "Připojený k relaci",
	"dialog.sketchfab_uploader.private": "Soukromý (Pro)",
	"dialog.sketchfab_uploader.password": "Heslo (Pro)",
	"action.uv_select_all": "Vybrat Vše",
	"action.uv_select_all.desc": "Vybere všechny prochy v daném UV dialogu",
	"panel.chat": "Chat",
	"edit_session.welcome": "Vítejte v relaci uživatele %0",
	"dialog.yes": "Ano",
	"dialog.no": "Ne",
	"generic.remove": "Odebrat",
	"generic.download": "Stáhnout",
	"generic.search": "Vyhledat",
	"dates.today": "Dnes",
	"dates.yesterday": "Včera",
	"dates.this_week": "Tento týden",
	"dates.weeks_ago": "%0 týdnů zpátky",
	"mode.start.new": "Nový model",
	"mode.start.recent": "Nedávno otevřené",
	"format.free": "Běžný model",
	"format.free.desc": "Model bez žádných omezení pro herní pluginy, renderování, apod.",
	"format.java_block": "Java model",
	"format.java_block.desc": "Blokový model pro edici Java. Velikost a rotace jsou omezeny.",
	"format.bedrock": "Bedrock model",
	"format.bedrock.desc": "Model pro edici Bedrock",
	"format.bedrock_old": "Bedrock Legacy Model",
	"format.bedrock_old.desc": "Model pro entitu pro Pre-1.12 Bedrock Edici",
	"format.modded_entity": "Model pro módované entity",
	"format.modded_entity.desc": "Model entity pro modifikace. Může být uložen jako soubor typu .java.",
	"format.optifine_entity": "OptiFine Entita",
	"format.optifine_entity.desc": "Vlastní model pro entitu pro OptiFine modifikaci",
	"keys.mouse": "Tlačítko Myši %0",
	"message.cleared_blank_faces.title": "Nevyplněné plochy",
	"message.cleared_blank_faces.message": "Blockbench nalezl %0 kostek bez žádné textury. Přejete si je odstranit?",
	"message.wireframe.enabled": "Drátový pohled zapnut",
	"message.wireframe.disabled": "Drátový pohled vypnut",
	"dialog.convert_project.title": "Konvertovat Projekt",
	"dialog.create_texture.double_use": "Udržovat obsazení více textur",
	"dialog.model_stats.title": "Statistiky modelu",
	"dialog.model_stats.cubes": "Kostky",
	"dialog.model_stats.locators": "Lokátory",
	"dialog.model_stats.groups": "Skupiny",
	"dialog.model_stats.vertices": "Vrcholy",
	"dialog.model_stats.faces": "Plochy",
	"settings.username": "Uživatelské Jméno",
	"settings.username.desc": "Uživatelské jméno pro úpravy relací",
	"settings.painting_grid": "Mřížka na Malování",
	"settings.painting_grid.desc": "Zobrazit mřížku na texturovaných prvcích v malovacím režimu",
	"action.convert_project": "Převést Projekt",
	"action.convert_project.desc": "Převede aktuální projekt na projekt pro jiný formát modelu",
	"action.close_project": "Zavřít Projekt",
	"action.close_project.desc": "Zavře aktuálně otevřený projekt",
	"action.export_bedrock": "Exportovat Geometrii Verze Bedrock",
	"action.export_bedrock.desc": "Exportuje model jako geometrický soubor Bedrock edice.",
	"action.save_project": "Uložit Projekt",
	"action.save_project.desc": "Uloží daný model jakožto projektový soubor",
	"action.save_project_as": "Uložit Projekt Jako",
	"action.save_project_as.desc": "Saves the current model as a project file at a new location",
	"action.export_over": "Uložit Model",
	"action.export_over.desc": "Uloží model, textury a animace přepisováním souborů",
	"action.add_locator": "Přidat Lokátor",
	"action.add_locator.desc": "Přidá nový lokátor pro ovládání pozic částic, vodítek, apod.",
	"action.uv_turn_mapping": "Otočit Mapování",
	"action.uv_turn_mapping.desc": "Otočí UV mapování o 90 stupňů",
	"action.remove_blank_faces": "Odstranit Prázdné Plochy",
	"action.remove_blank_faces.desc": "Zprůhlední všechny plochy bez textury ve výběru",
	"web.download_app": "Stáhnout Aplikaci",
	"uv_editor.turned": "Otočené Mapování",
	"display.reference.crossbow": "Kuše",
	"dialog.settings.search_results": "Vyhledat výsledky",
	"settings.animation_snap": "Přichycené Animace",
	"settings.animation_snap.desc": "Interval přitahování klíčových snímků na časové lince animace v krocích za sekundu",
	"action.import_optifine_part": "Vložit Částečný OptiFine Model",
	"action.import_optifine_part.desc": "Vloží částečný OptiFine model pro Optifine",
	"data.locator": "Lokátor",
	"mode.start.no_recents": "Žádné nedávno otevřené modely",
	"panel.element": "Prvek",
	"panel.element.position": "Pozice",
	"panel.element.size": "Velikost",
	"panel.element.origin": "Bod otáčení",
	"panel.element.rotation": "Rotace",
	"message.canvas_limit_error.title": "Limitační Error Plátna",
	"message.canvas_limit_error.message": "Akci nelze provést správně, protože formát limituje plátno na 48 jednotek. Chcete-li tomu zabránit, posuňte otočný bod.",
	"data.effect": "Efekt",
	"generic.name": "Jméno",
	"settings.recent_projects": "Kapacita Upravených Modelů",
	"settings.recent_projects.desc": "Maximální počet posledních upravovaných modelů k zapamatování",
	"settings.volume": "Hlasitost",
	"settings.volume.desc": "Kontrola hlasitosti pro zvukové efekty v animacích",
	"action.clear_timeline": "Vyčistit časovou linku",
	"action.clear_timeline.desc": "Vyčistit všechny nevybrané části těla z časové linky",
	"action.select_effect_animator": "Animovat Efekty",
	"action.select_effect_animator.desc": "Otevře časovou linku pro přidání zvuku a částicových efektů",
	"action.timeline_focus": "Filtrovat Kanály",
	"action.timeline_focus.desc": "Vybrat animační kanály pro zobrazení na časové lince",
	"timeline.particle": "Částice",
	"timeline.sound": "Zvuk",
	"timeline.effects": "Efekty",
	"data.format": "Formát",
	"format.optifine_part": "Částečný OptiFine model",
	"format.optifine_part.desc": "Částečný model [tj. JPM] jako součást pro model OptiFine entity",
	"action.reverse_keyframes": "Vyměnit Pořadí Snímků",
	"action.reverse_keyframes.desc": "Vymění pořadí vybraných klíčových snímků",
	"generic.help": "Výpomoc",
	"message.removed_faces": "Odstraněno %0 ploch",
	"dialog.sketchfab_uploader.draft": "Koncept",
	"action.slider_pos": "Posunout %0",
	"action.slider_pos.desc": "Posune prvky na ose %0",
	"action.slider_size": "Velikost %0",
	"action.slider_size.desc": "Změní velikost prvků na ose %0",
	"action.slider_rotation": "Otočit %0",
	"action.slider_rotation.desc": "Otočí prvky na ose %0",
	"action.slider_origin": "Osa otáčení %0",
	"action.slider_origin.desc": "Posune osu otáčení na ose %0",
	"action.rotate_cw": "Otočit %0 +90",
	"action.rotate_cw.desc": "Otočí vybrané prvky o 90° na ose %0",
	"action.rotate_ccw": "Otočit %0 -90",
	"action.rotate_ccw.desc": "Otočí vybrané prvky o -90° na ose %0",
	"action.flip": "Překlopit %0",
	"action.flip.desc": "Překlopí vybrané prvky na ose %0",
	"action.center": "Vycentrovat %0",
	"action.center.desc": "Vycentruje vybrané prvky na ose %0",
	"action.bring_up_all_animations": "Pozvednout Všechny Animace",
	"panel.bone": "Část Těla",
	"data.color": "Barva",
	"generic.export": "Uložit jako",
	"generic.none": "Žádný",
	"status_bar.recording": "Nahrávání Timelapse",
	"message.add_to_palette": "Přidáno do palety",
	"message.size_modifiers": "Podržte Ctrl nebo Shift (nebo obojí) pro transformaci po menších částech.",
	"message.timelapse_start": "Spuštění Časozběru",
	"message.timelapse_stop": "Zastavení Časozběru",
	"message.import_palette.replace_palette": "Nahradit starou paletu",
	"message.import_palette.threshold": "Prahová hodnota sloučení",
	"dialog.timelapse.interval": "Interval (sekundy)",
	"dialog.timelapse.source": "Zdroj",
	"dialog.timelapse.source.interface": "Rozhraní",
	"dialog.timelapse.source.locked": "Zamčený úhel",
	"dialog.timelapse.destination": "Cílová Složka",
	"layout.color.checkerboard": "Šachovnice",
	"layout.color.checkerboard.desc": "Pozadí plátna a UV editor",
	"layout.font.code": "Kódovaný Font",
	"layout.css": "Vlastní CSS soubor",
	"settings.category.paint": "Barvení",
	"settings.deactivate_size_limit": "Zakáz Velikostní Limitace",
	"settings.deactivate_size_limit.desc": "Zrušení velikostního limitu pro specifické formáty modelu. VAROVÁNÍ: Může způsobit nefunkčnost modelu z důvodu nepodporovaného formátu.",
	"settings.brush_opacity_modifier": "Modifikátor Průhlednosti Štětce",
	"settings.brush_opacity_modifier.desc": "Upraví průhlednost štětce při používání stylu (digitální tužka)",
	"settings.brush_size_modifier": "Modifikátor Velikosti Štětce",
	"settings.brush_size_modifier.desc": "Upraví velikost štětce při používání stylu (digitální tužka)",
	"settings.brush_modifier.pressure": "Tlak",
	"settings.brush_modifier.tilt": "Sklon",
	"category.color": "Barva",
	"action.import_theme": "Nahrát Vizuální Doplněk",
	"action.export_theme": "Exportovat Vizuální Doplněk",
	"action.export_theme.desc": "Vytvořit soubor vizuálního doplňku založeném na dosavadním nastavení",
	"action.slider_color_h": "Odstín",
	"action.slider_color_s": "Sytost",
	"action.slider_color_v": "Hodnota",
	"action.add_to_palette": "Přidat Do Palety Barev",
	"action.add_to_palette.desc": "Přidá vybranou barvu do palety barev",
	"action.import_palette": "Nahrát Paletu Barev",
	"action.import_palette.desc": "Pro nahrání palety barev pomocí souboru typu .bbpalette",
	"action.export_palette": "Exportovat Paletu Barev",
	"action.export_palette.desc": "Exportuje paletu barev jako soubor typu .bbpalette",
	"action.generate_palette": "Vygenerovat Paletu Barev",
	"action.generate_palette.desc": "Vygeneruje paletu barev z textury",
	"action.sort_palette": "Seřadit Paletu Barev",
	"action.sort_palette.desc": "Seřadí všechny barvy na paletě podle barvy a jasu",
	"action.timelapse": "Časozběr...",
	"action.timelapse.desc": "Natočí časozběr během vaší práce na modelu",
	"action.add_keyframe": "Přidat Snímek",
	"action.add_keyframe.desc": "Automaticky přidá snímek. Stisknutím klávesy shift vynutíte výchozí hodnoty",
	"action.bring_up_all_animations.desc": "Brings všechny modifikované animace do časové linky",
	"timeline.timeline": "Instrukce",
	"menu.palette.load.default": "Výchozí",
	"generic.import": "Vložit",
	"settings.brush_modifier.none": "Žádné",
	"action.export_entity": "Exportovat Entitu Verze Bedrock",
	"action.export_entity.desc": "Přidá aktuální model jako entitu do souboru mobs.json",
	"settings.highlight_cubes": "Zvýraznění prvků",
	"settings.highlight_cubes.desc": "Zvýrazní prvky při najetí myší nebo při jejich výběru",
	"action.add_marker": "Vložení Záložky",
	"action.add_marker.desc": "Vložit Záložku na časové lince",
	"timeline.pre_effect_script": "Skript",
	"format.skin": "Skin",
	"format.skin.desc": "Pro editaci hráčského skinu, nebo skinu entit",
	"message.sketchfab.setup_guide": "Want to learn how to set up models in Sketchfab? Read %0",
	"dialog.skin.title": "Vytvořit Skin",
	"dialog.skin.model": "Model",
	"action.toggle_skin_layer": "Přepnout Vrstvu Skinu",
	"action.toggle_skin_layer.desc": "Přepne na vrstvu pro oblečení u skinového modelu",
	"action.gui_light": "GUI Osvětlení",
	"action.gui_light.desc": "Vyberte způsob osvětlení položky v inventáři",
	"action.gui_light.side": "Boční Osvětlení",
	"action.gui_light.front": "Přední Osvětlení",
	"action.move_keyframe_back": "Posunout Snímky Zpět",
	"action.move_keyframe_forth": "Posunout Snímky Dopředu",
	"menu.help": "Pomoc",
	"menu.help.discord": "Discord Server",
	"menu.help.report_issue": "Nahlásit Problém",
	"menu.help.plugin_documentation": "Dokumentace API pluginu",
	"menu.help.search_action": "Vyhledat a Spustit Akci",
	"menu.help.donate": "Darovat",
	"menu.help.about": "O aplikaci...",
	"menu.preview.background.clipboard": "Nahrát ze Schránky",
	"dialog.ignore": "Ignorovat",
	"generic.unset": "Vymazat",
	"message.invalid_builtin_parent.title": "Neplatný předdefinovaný nadřazený prvek",
	"message.invalid_builtin_parent.message": "Odkaz na neplatný nadřazený model '%0' byl odstraněn, aby bylo možné soubor uložit jako platný model.",
	"dialog.resize_texture.fill": "Vyplnit",
	"dialog.resize_texture.fill.transparent": "Průhledný",
	"dialog.resize_texture.fill.color": "Barva",
	"dialog.resize_texture.fill.repeat": "Opakovat",
	"dialog.scale.element_pivot": "Základní osa otáčení",
	"dialog.scale.selection_center": "Výběr Středového bodu",
	"dialog.create_gif.length_mode": "Délkový režim",
	"dialog.create_gif.length_mode.seconds": "Sekundy",
	"dialog.create_gif.length_mode.frames": "Rámce",
	"dialog.create_gif.length_mode.animation": "Délka animace",
	"dialog.create_gif.length_mode.turntable": "Rotace točny",
	"dialog.save_angle.projection": "Projekce",
	"dialog.save_angle.projection.perspective": "Perspektiva",
	"dialog.save_angle.projection.orthographic": "Ortografické zobrazení",
	"dialog.sketchfab_uploader.animations": "Animace",
	"dialog.settings.theme": "Úprava vzhledu",
	"settings.category.interface": "Rozhraní",
	"settings.preview_checkerboard": "Náhled šachovnice",
	"settings.preview_checkerboard.desc": "Přepnout šachovnicové pozadí za náhledem",
	"settings.uv_checkerboard": "Šachovnice UV Editoru",
	"settings.uv_checkerboard.desc": "Přepnout šachovnicové pozadí za UV editorem",
	"category.paint": "Malování",
	"action.fill_mode.color_connected": "Připojené Barvy",
	"action.draw_shape_type": "Typ Tvaru",
	"action.draw_shape_type.rectangle": "Obdélník",
	"action.draw_shape_type.rectangle_h": "Obdélník (Dutý)",
	"action.draw_shape_type.ellipse": "Elipsa",
	"action.draw_shape_type.ellipse_h": "Elipsa (Dutá)",
	"action.draw_shape_type.line": "Přímka",
	"action.mirror_painting": "Zrcadlové Malování",
	"action.mirror_painting.description": "Zrcadlí tahy barvou na druhou stranu modelu",
	"action.lock_alpha": "Zamknout Kanál Alpha",
	"action.lock_alpha.description": "Zamkne průhlednost všech pixelů",
	"action.draw_shape_tool": "Nakreslit Tvar",
	"action.draw_shape_tool.desc": "Nástroj pro nakreslení jednoduchých tvarů na textury",
	"action.export_gltf": "Exportovat jako soubor typu glTF",
	"action.export_gltf.desc": "Export model and animations as glTF file to use in other 3D applications",
	"action.transform_space": "Transformační Prostor",
	"action.transform_space.desc": "Výchozí transformační prostor pro prvky a kostí",
	"action.transform_space.global": "Globální",
	"action.transform_space.local": "Lokální",
	"action.toggle_camera_projection": "Přepnout Projekci Kamery",
	"action.toggle_camera_projection.desc": "Přepíná projekci kamery mezi perspektivní a 2D zobrazením",
	"action.load_camera_angle": "Úhel kamery: %0",
	"action.load_camera_angle.desc": "Nastaví úhel kamery '%0'",
	"action.slider_face_tint": "Index Odstínu",
	"action.slider_face_tint.desc": "Nastaví index odstínu dané plochy. Hodnota -1 symbolizuje NENASTAVENO.",
	"menu.help.quickstart": "Rychlé Spuštění Wizard",
	"menu.help.developer": "Možnosti Vývojáře",
	"menu.help.developer.dev_tools": "Otevřít Vývojářské Nástroje",
	"menu.help.developer.reset_storage": "Resetovat na Tovární Nastavení",
	"menu.help.developer.reset_storage.confirm": "Jste si jisti, že chcete resetovat Blockbench do Továrního Nastavení? Toto rozhodnutí smaže všechny vaše nastavení, klávesové zkratky a pluginy.",
	"menu.help.developer.cache_reload": "Znovu Načíst Mezipaměť",
	"menu.preview.orthographic": "2D zobrazení",
	"menu.preview.save_angle": "Uložit Úhel...",
	"menu.preview.angle": "Úhly",
	"menu.preview.angle.initial": "Počáteční Úhel",
	"menu.preview.maximize": "Maximalizovat",
	"uv_editor.copy_selection": "Kopírovat Výběr",
	"uv_editor.paste_selection": "Vložit Výběr",
	"uv_editor.copy_paste_tool.place": "Vložit",
	"uv_editor.copy_paste_tool.mirror_x": "Zrcadlo osy X",
	"uv_editor.copy_paste_tool.mirror_y": "Zrcadlo osy Y",
	"uv_editor.copy_paste_tool.rotate": "Otočit o 90 Stupňů",
	"dialog.project.modded_entity_version": "Export Version",
	"dialog.save_angle.position": "Pozice Kamery",
	"dialog.save_angle.target": "Ohniskový Bod",
	"dialog.skin.pose": "Postoj",
	"layout.color.frame": "Rám Okna",
	"layout.color.frame.desc": "Okraj a záhlaví okna",
	"settings.large_grid_size": "Velikost blokové mřížky",
	"settings.large_grid_size.desc": "Rozměry Blokové Mřížky",
	"action.load_plugin_from_url": "Načíst Doplněk z Odkazu URL",
	"action.load_plugin_from_url.desc": "Načte doplněk ze serveru zadáním adresy URL",
	"action.cube_counter.desc": "Zobrazí aktuální počet prvků a další statistiky",
	"action.unlock_everything": "Odemknout Vše",
	"action.unlock_everything.desc": "Odemkne všechny skupiny a prvky v seznamu.",
	"action.load_palette": "Načíst Paletu Barev",
	"action.load_palette.desc": "Načte jednu z programových přednastavení palety barev",
	"action.toggle_locked": "Přepnout Zamčení",
	"action.toggle_locked.desc": "Přepne uzamčení vybraných prvků",
	"action.apply_display_preset": "Použít Přednastavení",
	"action.apply_display_preset.desc": "Použije výchozí, nebo vlastní zobrazovací přednastavení",
	"action.apply_display_preset.here": "Použít Na Tento Slot",
	"action.apply_display_preset.everywhere": "Použít Na Všechny Sloty",
	"action.resolve_keyframe_expressions": "Vyřešit Snímky",
	"action.resolve_keyframe_expressions.desc": "Řeší matematické výrazy vybraných klíčových snímků",
	"action.fold_all_animations": "Složit Všechny Animace",
	"menu.palette.load.empty": "Prázdný",
	"switches.lock": "Zamknout",
	"settings.render_sides": "Vykreslení Stran",
	"settings.render_sides.desc": "Vyberte, která strana plochy se vykreslí",
	"settings.render_sides.auto": "Automaticky",
	"settings.render_sides.front": "Vnější",
	"settings.render_sides.double": "Vnitřní a Vnější",
	"generic.enable": "Povoleno",
	"generic.disable": "Zakázáno",
	"generic.redacted": "Redigováno",
	"dialog.select_texture.import_all": "Nahrát Vše",
	"dialog.skin.layer_template": "Texturová vrstva",
	"about.version.up_to_date": "Aktuální",
	"about.version.update_available": "Verze %0 je k dispozici ke stažení",
	"settings.category.application": "Aplikace",
	"settings.streamer_mode": "Streamovací režim",
	"settings.streamer_mode.desc": "Schová citlivé informace, jako například Nedávno otevřené modely",
	"settings.automatic_updates": "Automatické Aktualizace",
	"settings.automatic_updates.desc": "Automaticky bude stahovat nové aktualizace a udržovat program Blockbench na nejnovější verzi",
	"action.rotation_space": "Prostor Otáčení",
	"action.focus_on_selection": "Vycentrování Pohledu na Výběr",
	"action.focus_on_selection.desc": "Zarovná kameru tak, aby směřovala ke středu aktuálního výběru",
	"action.jump_to_timeline_start": "Přeskočit na Počátek Animace",
	"action.jump_to_timeline_end": "Přeskočit na Konec Animace",
	"menu.help.updating": "Aktualizace (%0%)",
	"menu.help.update_failed": "Aktualizace Selhala",
	"menu.animation.loop.once": "Přehrát Jednou",
	"menu.animation.loop.hold": "Pozastavit na Posledním Snímku",
	"menu.animation.loop.loop": "Smyčka",
	"interface.streamer_mode_on": "Streamerský mod Povolen",
	"generic.reset": "Resetovat",
	"generic.restore": "Obnovit",
	"keys.mousewheel": "Kolečko myši",
	"message.delete_animation.title": "Vymazat animaci",
	"message.delete_animation.message": "Animace byla z Blockbenche odebrána. Přejete si ji také vymazat ze souboru, ve kterém byla uložena?",
	"message.no_animation_to_import": "Žádné animace k nahrání",
	"dialog.material_instances.title": "Materiální instance",
	"dialog.animation_import.title": "Vyberte požadované animace pro nahrání",
	"dialog.create_texture.padding": "Vnitřní okraj (výplň)",
	"settings.fov": "FOV",
	"settings.fov.desc": "Zorné pole kamery. Výchozí hodnota je 45",
	"settings.minify_bbmodel": "Řádkové Projektové Soubory",
	"settings.minify_bbmodel.desc": "Sepíše projektové soubory typu .bbmodel do jediného řádku",
	"action.edit_material_instances": "Upravit Instance Materiálu",
	"action.edit_material_instances.desc": "Pro úpravu jmen materiálních instancí pro geometrie bloku verze Bedrock",
	"action.save_all_animations": "Uložit Všechny Animace",
	"action.save_all_animations.desc": "Uloží všechny aktuálně načtené animace",
	"action.keyframe_interpolation": "Interpolace",
	"action.keyframe_interpolation.desc": "Pro vybrání režimu interpolace klíčových snímků",
	"action.keyframe_interpolation.linear": "Lineární",
	"action.keyframe_interpolation.catmullrom": "Hladká",
	"action.timeline_focus.hide_empty": "Schovat prázdní kanály",
	"menu.file.preferences": "Nastavení",
	"menu.animation.blend_weight": "Závažnost Smíšení",
	"menu.animation.save": "Uložit",
	"menu.animation.properties": "Vlastnosti...",
	"menu.animation.file": "Soubor",
	"menu.animation.snapping": "Přichytávání",
	"menu.animation.open_location": "Otevřít Lokaci Souboru",
	"panel.keyframe.add_data_point": "Přidat Snímkový Datový Bod",
	"panel.keyframe.remove_data_point": "Odstranit Datový Bod",
	"panel.keyframe.pre": "Před",
	"panel.keyframe.post": "Po",
	"generic.all": "Vše",
	"message.small_face_dimensions.title": "Nekompatibilní rozměry ploch",
	"message.small_face_dimensions.message": "Výběr obsahuje plochy, které jsou menší než 1 jednotka v jednom směru. Mapovací systém Box UV považuje všechny plochy pod touto prahovou hodnotou za 0 pixelů široké. Textura na těchto plochách proto nemusí fungovat správně.",
	"message.small_face_dimensions.face_uv": "Dosavadní formát podporuje per-face UV mapy, který zvládá malé rozměry plochy. Běžte do \"Soubor\" -> \"Projekt...\" a odškrtněte \"Box UV\".",
	"dialog.plugins.outdated_client": "Je vyžadována novější verze programu Blockbench",
	"dialog.plugins.outdated_plugin": "Plugin je zastaralý a na této verzi Blockbenche nefunguje",
	"settings.motion_trails": "Pohybové cesty",
	"settings.motion_trails.desc": "Zobrazení pohybových cest v animačním editoru",
	"settings.antialiasing": "Vyhlazování",
	"settings.antialiasing.desc": "Přepnout vyhlazování v náhledu. Restartujte Blockbench pro uplatnění změn",
	"action.timeline_frame_back": "Skočit o 1 Snímek Zpět",
	"action.timeline_frame_forth": "Skočit o 1 Snímek Dopředu",
	"panel.bone.ik": "Inverzní kinematika (Ve vývoji)",
	"settings.particle_tick_rate": "Četnost tiků Částic",
	"settings.particle_tick_rate.desc": "Četnost tiků pro efekty částic v ticích za sekundu. Výchozí hodnota je 30",
	"action.lock_motion_trail": "Zamknout Sledování Pohybu",
	"action.lock_motion_trail.desc": "Zamknout sledování pohybu aktuálně vybrané skupiny",
	"menu.animation_file.unload": "Nenačtený Soubor s Animací",
	"data.null_object": "Nulový Objekt",
	"status_bar.toggle_sidebar": "Přepnout Postranní Panel",
	"message.load_plugin_failed.title": "Nepodařilo se nahrát doplněk",
	"message.load_plugin_failed.message": "Ujistěte se, že název základního souboru pluginu odpovídá ID pluginu `%0`, jak je uvedeno v Plugin.register().",
	"dialog.project.uv_mode": "UV Režim",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-face UV",
	"dialog.project.texture_size": "Velikost Textury",
	"dialog.animation_export.title": "Vyberte požadované animace pro exportování",
	"dialog.create_texture.rearrange_uv": "Přeskupit UV",
	"layout.color.subtle_text": "Jemný Text",
	"layout.color.subtle_text.desc": "Druhotný barva textu s menším kontrastem",
	"settings.interface_scale": "Měřítko Rozhraní",
	"settings.interface_scale.desc": "Měřítko celého rozhraní Blockbench",
	"settings.background_rendering": "Vykreslování Pozadí",
	"settings.background_rendering.desc": "Aktualizuje náhled, zatímco okno není zaostřeno",
	"settings.ctrl_shift_size": "Ctrl + Shift Rozlišení",
	"settings.ctrl_shift_size.desc": "Rozlišení mřížky při držení klávesnice ctrl a shift",
	"settings.hardware_acceleration": "Hardwarová Akcelerace",
	"settings.hardware_acceleration.desc": "Zadá úkoly vykreslování na grafickou kartu. Chcete-li použít změny, restartujte Blockbench",
	"action.explode_skin_model": "Exploze Modelu Skinu",
	"action.explode_skin_model.desc": "Přepíná zobrazení exploze, které vám umožní upravovat zakryté tváře",
	"action.export_minecraft_skin": "Exportovat Minecraft Skin",
	"action.export_minecraft_skin.desc": "Exportuje Minecraft skin jako PNG texturu",
	"action.add_null_object": "Přidat Nulový Objekt",
	"action.add_null_object.desc": "Přidá nový nulový objekt",
	"action.animated_texture_frame": "Animovaný Snímek Textury",
	"action.animated_texture_frame.desc": "Nastaví aktuální snímek animované textury",
	"action.export_animation_file": "Exportovat Animaci...",
	"action.export_animation_file.desc": "Exportuje výběr animací do nového souboru",
	"action.timeline_graph_editor": "Přepnout Editor Grafů",
	"action.timeline_graph_editor.desc": "Přepíná časovou osu mezi zobrazením editoru grafů a zobrazením klíčových snímků",
	"menu.file.recent.clear": "Vymaže poslední soubory",
	"switches.shade": "Stín\n",
	"generic.share": "Sdílet",
	"dates.minute": "%0 Minuta",
	"dates.minutes": "%0 Minuty",
	"dates.hour": "%0 Hodina",
	"dates.hours": "%0 Hodiny",
	"dates.day": "%0 Den",
	"dates.days": "%0 Dny",
	"dates.week": "%0 Týden",
	"dates.weeks": "%0 Týdny",
	"dates.year": "%0 Rok",
	"dates.years": "%0 Roky",
	"message.installed_plugin": "Doplněk %0 úspěšně nainstalován",
	"message.installed_plugin_fail": "Nepodařilo se nainstalovat doplněk %0",
	"dialog.share_model.title": "Sdílet Model",
	"dialog.share_model.expire_time": "Čas Expirace",
	"dialog.share_model.failed": "Nepodařil ose nahrát model",
	"action.import_java_block_model": "Přidat Java model Bloku/Předmětu",
	"action.import_java_block_model.desc": "Přidat Minecraft Java model bloku/předmětu ze souboru json to aktuálního modelu",
	"action.share_model": "Sdílet...",
	"action.share_model.desc": "Vygeneruje krátký odkaz pro sdílení vašeho modelu",
	"action.import_project": "Nahrát Projekt",
	"action.import_project.desc": "Nahraje další projekt z .bbmodel souboru do daného projektu",
	"dialog.toolbar_edit.hidden_tools": "Některé nástroje mohou být skryté, protože nejsou k dispozici v aktuálním režimu, formátu nebo situaci.",
	"settings.camera_near_plane": "Kamera Blízko Roviny",
	"settings.camera_near_plane.desc": "Minimální vzdálenost od kamery, kde se objekty vykreslují. Vyšší hodnoty snižují Z-fighting. Výchozí hodnota je 1.",
	"mode.start.keymap_preference.desc": "Pokud s programem Blockbench začínáte, ale máte zkušenosti s jiným 3D programem, můžete si zvolit mapovaní klávesových zkratek, na které jste zvyklý. V Nastavení lze i později tuto volbu změnit.",
	"message.load_keymap": "Opravdu chcete načíst toto mapování kláves? Přepíšou se tím vaše aktuální klávesové zkratky.",
	"message.keymap_loaded": "Mapování kláves načteno",
	"dialog.convert_project.current_format": "Tento formát",
	"dialog.create_texture.rearrange_uv.desc": "Vytvořit nové UV uspořádání, aby každá plocha měla vlastní místo na textuře",
	"dialog.create_texture.power.desc": "Uzamknout automatickou velikost textury na mocninu 2, například 64 nebo 128. Některé renderery to můžou vyžadovat",
	"dialog.create_texture.double_use.desc": "Pokud již dva prvky mají přiřazen stejný UV prostor, ponechat je tak i v nové mapě",
	"dialog.create_texture.padding.desc": "Přidat malou mezeru mezi jednotlivými částmi textury",
	"dialog.create_texture.resolution.desc": "Výška a šířka textury",
	"dialog.create_gif.color": "Barva pozadí",
	"dialog.save_angle.zoom": "Přiblížení",
	"dialog.skin.variant": "Varianta",
	"dialog.flip_animation.info": "Protilehlé části těla jsou označeny klíčovými slovy 'left' a 'right' v jejich jménu.",
	"dialog.export_private_settings.title": "Soukromá nastavení",
	"dialog.export_private_settings.message": "Vaše složka obsahuje následující soukromé informace: **%0**. Pokud plánujete soubor sdílet s někým jiným, tyto informace vynechejte.",
	"dialog.export_private_settings.keep": "Ponechat",
	"settings.timecode_frame_number": "Zobrazovat časové známky jako čísla snímků",
	"settings.timecode_frame_number.desc": "Zobrazovat zlomkové časové známky na časové lince jako číslo snímku místo centivteřin",
	"settings.animation_sample_rate": "Vzor sekvence animace",
	"settings.animation_sample_rate.desc": "Vzorkovací frekvence (počet vzorků za sekundu) pro křivky, které daný formát nativně nepodporuje",
	"keybind.preview_zoom": "Přiblížené zobrazení",
	"action.gradient_tool": "Přechod",
	"action.gradient_tool.desc": "Vytvořit plynulou texturu barvy",
	"action.import_settings": "Importovat nastavení",
	"action.import_settings.desc": "Vložit .bbsettings soubor",
	"action.export_settings": "Exportovat nastavení",
	"action.export_settings.desc": "Exportovat nastavení Blockbenche jako soubor .bbsettings",
	"action.load_keymap": "Nahrát rozhrání klávesnice",
	"action.load_keymap.default": "Výchozí (Trackpad / Myš)",
	"action.load_keymap.mouse": "Výchozí (Myš)",
	"action.load_keymap.default.desc": "Původní rozhrání klávesnice pro Blockbench. Navigace zobrazení je nastavená na trackpad laptopů",
	"action.load_keymap.mouse.desc": "Původní rozhrání klávesnice pro Blockbench. Navigace zobrazení je nastavená na prostřední tlačítko myši",
	"action.load_keymap.blender.desc": "Rozhrání klávesnice podobné programu blender",
	"action.load_keymap.cinema4d.desc": "Rozhrání klávesnice podobné programu Cinema 4D",
	"action.load_keymap.maya.desc": "Rozhrání klávesnice podobné programu Autodesk Maya",
	"action.import_keymap": "Importovat rozhrání klávesnice",
	"action.import_keymap.desc": "Nahrát zkraty kláves (.bbkeymap soubor)",
	"action.export_keymap": "exportovat rozhrání klávesnice",
	"action.export_keymap.desc": "exportovat rozhrání klávesnice jako soubor typu .bbkeymap",
	"action.edit_history": "Upravit...",
	"action.edit_history.desc": "Ukázat historii úprav včetně Undo a Redo oprav",
	"action.group_elements": "Seskupit prvky",
	"action.group_elements.desc": "Zabalit vybrané prvky do nové skupiny",
	"action.unfold_groups": "Rozbalit skupiny",
	"action.unfold_groups.desc": "Rozbalit skupiny v outlineru",
	"action.edit_bedrock_binding": "Upravit nastavení",
	"action.edit_bedrock_binding.desc": "Změnit, ke které části těla je geometrie vázána",
	"action.pick_screen_color": "Vybrat barvu z obrazovky",
	"action.pick_screen_color.desc": "Vyberte barvu odkudkoli na obrazovce",
	"action.view_mode": "Režim zobrazení",
	"action.view_mode.desc": "Změň režim zobrazení modelu",
	"action.view_mode.textured": "Texturováno",
	"action.view_mode.solid": "Pevný",
	"action.view_mode.wireframe": "Drátěný model",
	"action.toggle_sidebars": "Přepnout postranní lišty",
	"action.toggle_sidebars.desc": "Povolit nebo zakázat postranní panely",
	"action.set_animation_end": "Nastavit konec animace",
	"action.set_animation_end.desc": "Nastavit konec vybrané animace na aktuální čas na časové ose",
	"action.flip_animation": "Převrátit animaci",
	"action.flip_animation.desc": "Otočí část animace tak, že zkopíruje vybrané klíčové snímky na druhou stranu modelu",
	"action.graph_editor_zero_line": "Zahrnout nulovou čáru",
	"action.graph_editor_zero_line.desc": "Zda grafický editor vždy zahrnuje nulovou čáru do zobrazení",
	"menu.texture.render_mode": "Režim vykreslování",
	"menu.texture.render_mode.emissive": "Emisivní",
	"menu.texture.render_mode.layered": "Vrstvený",
	"menu.preview.angle.edit": "Upravit úhel…",
	"menu.animation.start_delay": "Zpoždění startu",
	"menu.animation.loop_delay": "Zpoždění smyčky",
	"menu.animation.flip_keyframes": "Otočit klíčové snímky",
	"menu.mobile_keyboard.disable_all": "Zakázat vše",
	"panel.keyframe.toggle_uniform_scale": "Přepnout jednotné měřítko",
	"camera_angle.common_isometric_right": "Isometrická pravá (2:1)",
	"camera_angle.common_isometric_left": "Isometrická levá (2:1)",
	"camera_angle.true_isometric_right": "Skutečná Isometrická pravá (30°)",
	"camera_angle.true_isometric_left": "Skutečná Isometrická levá (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Aktualizovat na předběžné verze",
	"settings.update_to_prereleases.desc": "Automaticky aktualizovat na beta verze Blockbench pro testování nových funkcí. Předběžné verze mohou být nestabilní, nepovolujte tuto možnost, pokud Blockbench používáte pro práci nebo jiné důležité projekty.",
	"data.separator.spacer": "Mezera",
	"data.separator.linebreak": "Zalomení řádku",
	"data.setting": "Nastavení",
	"generic.select_all": "Vybrat vše",
	"generic.select_none": "Zrušit výběr",
	"projects.new_tab": "Nová karta",
	"projects.close_tab": "Zavřít kartu",
	"message.invalid_format.title": "Neplatný formát",
	"message.invalid_format.message": "Tento model byl vytvořen ve formátu '%0', který ve vaší instalaci Blockbench není k dispozici. Pravděpodobně budete potřebovat konkrétní plugin, abyste jej mohli správně otevřít.",
	"message.invalid_link": "Neplatný nebo vypršelý odkaz na model",
	"message.default_textures.current": "Aktuální cesta",
	"message.update_after_restart": "Aktualizace bude nainstalována po příštím restartu",
	"message.copy_paste_tool_viewport": "Tento nástroj lze používat pouze v 2D editoru",
	"dialog.project.shadow_size": "Velikost stínu",
	"dialog.find_replace.target": "Cíl",
	"dialog.find_replace.target.element_names": "Jména prvků",
	"dialog.find_replace.target.group_names": "Jména skupin",
	"dialog.find_replace.target.animation_names": "Jména animací",
	"dialog.find_replace.target.keyframe_values": "Hodnoty klíčových snímků",
	"dialog.find_replace.find": "Najít",
	"dialog.find_replace.replace": "Nahradit",
	"dialog.find_replace.regex": "Regulární výraz",
	"dialog.add_primitive.shape": "Tvar",
	"dialog.add_primitive.shape.circle": "Kruh",
	"dialog.add_primitive.shape.tube": "Tubus",
	"dialog.add_primitive.shape.cone": "Kužel",
	"dialog.add_primitive.shape.cylinder": "Válec",
	"dialog.add_primitive.shape.sphere": "Koule",
	"dialog.add_primitive.shape.torus": "Toroid",
	"dialog.add_primitive.shape.cube": "Kvádr",
	"dialog.add_primitive.shape.pyramid": "Pyramida",
	"dialog.add_primitive.diameter": "Průměr",
	"dialog.add_primitive.height": "Výška",
	"dialog.add_primitive.sides": "Strany",
	"dialog.add_primitive.minor_diameter": "Tloušťka",
	"dialog.add_primitive.minor_sides": "Menší strany",
	"dialog.create_texture.combine_polys": "Sloučit UV soustavy",
	"dialog.create_texture.combine_polys.desc": "Sloučit plochy do propojených UV soustav",
	"dialog.model_stats.meshes": "Sítě",
	"dialog.export_private_settings.omit": "Vynechat",
	"layout.select": "Vybrat",
	"layout.options": "Možnosti",
	"layout.color": "Barevné schéma",
	"layout.documentation": "Dokumentace",
	"layout.color.bright_ui_text": "Světlý UI text",
	"layout.color.bright_ui_text.desc": "Text na světlém pozadí",
	"layout.name": "Název",
	"layout.author": "Autor",
	"settings.dialog.desc": "Zobrazit \"%0\" dialog",
	"settings.export_empty_groups": "Exportovat prázdné skupiny",
	"settings.export_empty_groups.desc": "Zahrnout skupiny bez obsahu do exportovaných souborů",
	"category.separators": "Oddělovače",
	"keybind.preview_area_select": "Výběr oblasti",
	"action.color_erase_mode": "Režim mazání",
	"action.color_erase_mode.desc": "S povoleným režimem mazání nástroje jako Výplň a Obdélník odečítají barvy místo toho, aby je přidávaly",
	"action.open_from_link": "Otevřít model z odkazu...",
	"action.open_from_link.desc": "Otevřít model z blckbn.ch URL",
	"action.import_obj": "Importovat OBJ model",
	"action.import_obj.desc": "Importuje objekty z OBJ modelu jako sítě",
	"action.add_plugin": "Nainstalovat Plugin",
	"action.add_plugin.desc": "Nainstalovat plugin prostřednictvím Action Control",
	"action.remove_plugin": "Odinstalovat Plugin",
	"action.remove_plugin.desc": "Odinstalovat plugin prostřednictvím Action Control",
	"action.add_mesh": "Přidat síť",
	"action.add_mesh.desc": "Přidá novou síť",
	"action.add_texture_mesh": "Přidat texturu sítě",
	"action.add_texture_mesh.desc": "Přidá novou texturu sítě",
	"action.find_replace": "Najít/Nahradit...",
	"action.find_replace.desc": "Najít a nahradit části názvů",
	"action.hide_everything_except_selection": "Schovat vše vyjma výběru",
	"action.hide_everything_except_selection.desc": "Přepne viditelnost všech prvků kromě vybraných",
	"action.transform_space.normal": "Normální",
	"action.selection_mode": "Režim výběru",
	"action.selection_mode.desc": "Změnit způsob výběru prvků v zobrazení",
	"action.selection_mode.object": "Objekt",
	"action.selection_mode.face": "Plocha",
	"action.selection_mode.vertex": "Vrchol",
	"action.create_face": "Vytvořit plochu nebo hranu",
	"action.create_face.desc": "Vytvoří novou plochu nebo hranu mezi vybranými vrcholy",
	"action.convert_to_mesh": "Přeměnit na síť",
	"action.convert_to_mesh.desc": "Převést vybrané prvky na sítě",
	"action.invert_face": "Otočit plochu",
	"action.invert_face.desc": "Otočí vybrané plochy, aby směřovaly opačným směrem",
	"action.extrude_mesh_selection": "Vytáhnout výběr",
	"action.extrude_mesh_selection.desc": "Vytáhne vybrané části sítě",
	"action.loop_cut": "Smyčkový řez",
	"action.loop_cut.desc": "Rozdělí síť smyčkou podél vybrané hrany",
	"action.merge_meshes": "Sloučit sítě",
	"action.merge_meshes.desc": "Sloučit více sítí do jedné",
	"action.keyframe_uniform": "Jednotné měřítko",
	"action.keyframe_uniform.desc": "Uplatní jednotné měřítko na vybraných klíčových snímcích",
	"menu.locator.ignore_inherited_scale": "Ignorovat převzaté měřítko",
	"menu.texture.elements": "Použít na prvky",
	"uv_editor.transparent_face": "Průhledná plocha",
	"display.pose_angle": "Úhel pózy (pouze pro náhled)",
	"data.mesh": "Síť",
	"dialog.create_texture.type": "Typ",
	"dialog.create_texture.type.blank": "Prázdný",
	"dialog.create_texture.type.template": "Šablona textury",
	"dialog.create_texture.type.color_map": "Šablona s jednotnou barvou",
	"dialog.sketchfab_uploader.suggested_tags": "Doporučené tagy",
	"dialog.sketchfab_uploader.category": "Kategorie",
	"dialog.sketchfab_uploader.category2": "Kategorie 2",
	"layout.restore_backup": "Vlastní motiv „%0“ byl přepsán. Klikněte sem pro jeho obnovení.",
	"layout.borders": "Okraje",
	"action.fill_mode.element": "Prvek",
	"action.inset_mesh_selection": "Vsadit výběr",
	"action.inset_mesh_selection.desc": "Vsadí dovnitř vybrané částí sítě",
	"action.dissolve_edges": "Odstranit hrany",
	"action.dissolve_edges.desc": "Odstraní vybrané hrany v síti a sloučí plochy, které je rozdělují",
	"action.split_mesh": "Rozdělit síť",
	"action.split_mesh.desc": "Rozdělí vybrané plochy sítě do nové",
	"action.merge_vertices": "Sloučit vrcholy",
	"action.merge_vertices.desc": "Sloučí vybrané vrcholy do pozice prvního vybraného vrcholu",
	"action.view_mode.normal": "Orientace plochy",
	"action.snap_uv_to_pixels": "Přichytit UV k pixelům",
	"action.snap_uv_to_pixels.desc": "Přichytí vybrané UV vrcholy k mřížce pixelů",
	"menu.file.import.import_open_project": "Importovat otevřený projekt",
	"menu.help.unlock_projects": "Odemknout Všechny Projekty",
	"status_bar.selection.faces": "%0 Ploch",
	"status_bar.selection.vertices": "%0 Vrcholů",
	"message.merged_vertices": "Nalezeno a sloučeno %0 vrcholů na %1 místech",
	"settings.vertex_merge_distance": "Vzdálenost pro sloučení vrcholů",
	"settings.vertex_merge_distance.desc": "Vzdálenost, v rámci které jsou vrcholy spojeny pomocí sloučení dle vzdálenosti",
	"settings.show_only_selected_uv": "Zobrazit pouze vybrané UV",
	"settings.show_only_selected_uv.desc": "Zobrazí ve výchozím nastavení pouze vybrané UV plochy v UV editoru",
	"action.merge_vertices.merge_all": "Sloučit vše",
	"action.merge_vertices.merge_all_in_center": "Sloučit vše do středu",
	"action.merge_vertices.merge_by_distance": "Sloučit podle vzdálenosti",
	"action.merge_vertices.merge_by_distance_in_center": "Sloučit podle vzdálenosti do středu",
	"action.uv_rotate_left": "Otočit UV doleva",
	"action.uv_rotate_left.desc": "Otočí vybrané UV plochy proti směru hodinových ručiček",
	"action.uv_rotate_right": "Otočit UV doprava",
	"action.uv_rotate_right.desc": "Otočí vybrané UV plochy po směru hodinových ručiček",
	"menu.uv.display_uv": "Zobrazit UV",
	"menu.uv.display_uv.selected_faces": "Vybrané plochy",
	"menu.uv.display_uv.selected_elements": "Všechny Plochy",
	"menu.uv.display_uv.all_elements": "Všechny Plochy Všech Prvků",
	"menu.paste.face": "UV Plocha",
	"menu.paste.mesh_selection": "Výběr sítě",
	"menu.paste.outliner": "Prvky",
	"uv_editor.show_all_faces": "Zobrazit Všechny Plochy",
	"uv_editor.show_selected_faces": "Zobrazit Vybrané Plochy",
	"status_bar.selection.edges": "%0 Hran",
	"action.selection_mode.edge": "Hrana",
	"message.cannot_re_import.title": "Model nelze znovu importovat",
	"message.cannot_re_import.message": "Exportovaný formát modelu nelze do Blockbench znovu importovat. Ujistěte se, že model uložíte jako projektový soubor.",
	"generic.default": "Výchozí",
	"units.pixels_per_meter": "%0 Pixelů na Metr",
	"mode.pose": "Póza",
	"modifier_actions.resize_both_sides": "Změnit velikost v obou směrech",
	"modifier_actions.resize_one_side": "Změnit velikost v jednom směru",
	"modifier_actions.draw_line": "Nakreslit linii",
	"modifier_actions.drag_without_snapping": "Táhnout bez přichytávání",
	"modifier_actions.stretch_keyframes": "Roztáhnout klíčové snímky",
	"modifier_actions.resize_background": "Změnit velikost pozadí",
	"modifier_actions.select_multiple": "Vybrat více",
	"modifier_actions.select_range": "Vybrat rozsah",
	"modifier_actions.drag_to_duplicate": "Přetažením duplikovat",
	"modifier_actions.uniform_scaling": "Jednotné Škálování",
	"modifier_actions.snap_direction": "Směr Přichycení",
	"message.no_valid_elements": "Nebyl vybrán žádný platný prvek...",
	"dialog.add_primitive.shape.plane": "Rovina",
	"dialog.save_angle.rotation_mode": "Režim Rotace",
	"dialog.save_angle.rotation": "Rotace",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Automaticky skrýt panel záložek",
	"settings.hide_tab_bar.desc": "Skryje panel záložek, když je otevřena pouze jedna záložka",
	"settings.status_bar_modifier_keys": "Navrhovat modifikační klávesy ve stavovém řádku",
	"settings.status_bar_modifier_keys.desc": "Zobrazit ve stavovém řádku navrhované modifikační klávesy s ohledem na kontext",
	"settings.ground_plane": "Zemnící rovina",
	"settings.ground_plane.desc": "Zobrazit rovinu podlahy pod modelem",
	"settings.preview_paste_behavior": "Výchozí chování vkládání do zobrazení",
	"settings.preview_paste_behavior.desc": "Vyberte chování pro vkládání do zobrazení v Režimu úprav a k dispozici bude více možností.",
	"settings.preview_paste_behavior.always_ask": "Vždy se ptát",
	"action.new_window": "Nové Okno",
	"action.new_window.desc": "Otevře nové Blockbench okno",
	"action.export_collada": "Exportovat Collada model (dae)",
	"action.export_collada.desc": "Exportovat model a animace jako dae soubor pro použití v jiných 3D editorech",
	"action.paint_mode_uv_overlay": "UV Překrytí",
	"action.paint_mode_uv_overlay.desc": "Zobrazit UV mapu jako překrytí v režimu malování",
	"action.bake_animation_into_model": "Implementace animované pózy do modelu",
	"action.bake_animation_into_model.desc": "Implementuje právě zobrazený snímek animace do modelu. Použije se pouze rotace a poloha, měřítko se ignoruje.",
	"action.keyframe_interpolation.step": "Krok",
	"action.set_ik_target": "Stanovit IK cíl",
	"action.set_ik_target.desc": "Vybere cílovou část těla, kterou má tento nulový objekt přesunout pomocí inverzní kinematiky",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Úhel Kamery",
	"menu.action_control.recent_in_streamer_mode": "Jste si jistí? Streamer Režim je zapnutý",
	"menu.action_control.recent_in_streamer_mode.desc": "Přejete si zobrazit nedávné modely?",
	"menu.tools": "Nástroje",
	"menu.file.recent.more": "Zobrazit více...",
	"menu.null_object.lock_ik_target_rotation": "Zamknout IK rotaci cíle",
	"menu.animation_file.import_remaining": "Importovat Zbývající ze Souboru",
	"edit.loop_cut.offset": "Posun",
	"edit.extrude_mesh_selection.extend": "Rozšířit",
	"cube.color.pink": "Růžová",
	"cube.color.silver": "Stříbrná",
	"dialog.plugins.offline": "Žádné připojení k internetu",
	"dialog.create_texture.pixel_density": "Hustota Pixelů",
	"dialog.create_texture.pixel_density.desc": "Hustota pixelů textury, v pixelech na metr. Velikost mapy textury se může lišit v závislosti na množství a velikosti prvků.",
	"panel.skin_pose": "Pozice",
	"panel.skin_pose.none": "Žádný",
	"panel.skin_pose.natural": "Přirozený",
	"panel.skin_pose.walking": "Chůze",
	"panel.skin_pose.crouching": "Dřepění",
	"panel.skin_pose.sitting": "Sezení",
	"panel.skin_pose.jumping": "Skákání",
	"panel.skin_pose.aiming": "Zamíření",
	"edit.loop_cut.direction": "Směr",
	"data.texture_mesh": "Textura sítě",
	"generic.left": "Levý",
	"generic.right": "Pravý",
	"mode.start.quick_setup": "Rychlé nastavení",
	"mode.start.keymap": "Rozhrání Klávesnice",
	"mode.start.quick_setup.more_themes": "Více...",
	"dialog.resize_texture.animation_frames": "Snímky Animace",
	"dialog.export_emission_map.title": "Exportovat Emisní Mapu",
	"dialog.export_emission_map.format": "Formát",
	"dialog.export_emission_map.format.luminance": "Jas",
	"dialog.export_emission_map.format.luminance_inverted": "Invertovaný jas",
	"dialog.export_emission_map.format.colors": "Barvy",
	"dialog.export_emission_map.threshold": "Prahová Hodnota Průhlednosti",
	"dialog.export_emission_map.round_up": "Zaokrouhlit Nahoru na %0 x %1",
	"dialog.export_emission_map.flip_y": "Převrátit osu Y",
	"dialog.select.type": "Typ Prvku",
	"dialog.create_texture.max_edge_angle": "Prahový Úhel Hrany",
	"dialog.create_texture.max_edge_angle.desc": "Maximální úhel mezi dvěma plochami, pod kterým budou stále spojeny",
	"dialog.create_texture.max_island_angle": "Prahový úhel UV soustav",
	"dialog.create_texture.max_island_angle.desc": "Maximální úhel, který lze kombinovat do stejné UV soustavy",
	"settings.mobile_panel_side": "Mobilní strana panelu",
	"settings.mobile_panel_side.desc": "Vybere, na které straně obrazovky se zobrazí panely při použití Blockbenche ​v orientaci na šířku",
	"settings.obj_face_export_mode": "Režim exportu plochy OBJ",
	"settings.obj_face_export_mode.desc": "Zvolte, zda má exportér OBJ převést všechny plochy na trojúhelníky nebo čtyřúhelníky",
	"settings.obj_face_export_mode.both": "Výchozí",
	"settings.obj_face_export_mode.tris": "Převést na Trojúhelníky",
	"settings.obj_face_export_mode.quads": "Převést na Čtyřúhelníky",
	"action.seam_tool": "Nástroj na švy",
	"action.seam_tool.desc": "Nástroj pro definování UV švů na hranách sítě",
	"action.resolve_group": "Vyřešit skupinu",
	"action.resolve_group.desc": "Vyřeší skupinu a zároveň zachová její podřízené položky na stejném místě",
	"action.move_to_group": "Přesunout do",
	"action.move_to_group.desc": "Přesune vybrané prvky do jiné skupiny nebo prvku osnovy",
	"action.select_seam": "Vybrat UV šev",
	"action.select_seam.desc": "Vybere režim UV švu pro vybrané hrany",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Sloučit",
	"action.select_seam.divide": "Rozdělit",
	"action.adjust_brightness_contrast": "Upravit Jas a Kontrast...",
	"action.adjust_brightness_contrast.desc": "Upraví jas a kontrast vybrané textury",
	"action.adjust_saturation_hue": "Upravit Sytost a Odstín...",
	"action.adjust_saturation_hue.desc": "Upraví sytost a odstín vybrané textury",
	"action.invert_colors": "Invertovat Barvy",
	"action.invert_colors.desc": "Invertuje všechny barvy vybrané textury",
	"action.adjust_curves": "Upravit křivky...",
	"action.adjust_curves.desc": "Upraví jas křivek vybrané textury",
	"action.flip_texture_x": "Převrátit Horizontálně",
	"action.flip_texture_y": "Převrátit Vertikálně",
	"action.resize_texture": "Změnit Velikost Textury...",
	"action.view_mode.uv": "UV náhled",
	"action.append_to_template": "Přidat prvky do šablony...",
	"action.append_to_template.desc": "Přidá aktuálně vybrané prvky do šablony textury",
	"action.move_texture_with_uv": "Přesunout texturu s UV",
	"action.move_texture_with_uv.desc": "Přemístí texturu plochy společně s UV plochami",
	"action.timeline_setups": "Nastavení Časové Osy",
	"action.save_timeline_setup": "Uložit Nastavení Časové Osy...",
	"action.save_timeline_setup.desc": "Uložit přednastavení pro aktuálně vybrané animátory a kanály",
	"menu.texture": "Textura",
	"menu.texture.render_mode.default": "Výchozí",
	"menu.texture.merge_onto_texture": "Sloučit s texturou výše",
	"menu.animation.unload": "Uvolnit",
	"panel.timeline": "Časová Osa",
	"action.pan_tool": "Posun",
	"action.pan_tool.desc": "Nástroj pro navigaci v zobrazení a editoru textur",
	"mode.start.recent.favorite": "Označit jako Oblíbené",
	"mode.start.info": "Info",
	"mode.start.target": "Cíl",
	"mode.start.start": "Spustit",
	"mode.start.create_new": "Vytvořit Nový Model",
	"mode.start.format.informations": "Užitečné vědět:",
	"mode.start.format.resources": "Zdroje:",
	"format.free.info.meshes": "V tomto formátu můžete vytvářet low-poly modely pomocí krychlí a vlastních tvarovaných meshů.",
	"format.free.info.limitation": "Modely nelze načíst do her, které vyžadují speciální formáty, například Minecraft.",
	"format.skin.info.skin": "Tento formát je určen pro tvorbu skinů a textur entit v Minecraftu.",
	"format.skin.info.model": "Model nelze změnit. Chcete-li ho změnit, převeďte jej do jiného formátu pomocí nabídky **Soubor** > **Konvertovat projekt**.",
	"format.java_block.info.rotation": "Rotace jsou omezeny na jednu osu u každého prvku",
	"format.java_block.info.size": "Velikost modelu je omezena na 3 x 3 x 3 bloky. V nastavení zobrazení však můžete modely předmětů zvětšit",
	"format.java_block.info.animation": "Tento formát nepodporuje animace v klasickém Minecraftu. Pokud vytváříte mod, můžete k animaci modelů použít GeckoLib. Pokud ne, jediný způsob animace je přepnout model pomocí příkazů nebo animovaných textur.",
	"format.bedrock.info.textures": "Každý model může mít pouze jednu texturu",
	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Model bloku pro Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "Velikost jednotlivých kostek je omezena na celá čísla.",
	"format.modded_entity.info.format": "Modely jsou psány v kódu Java namísto specializovaných datových struktur jako všechny ostatní exportní formáty Blockbench.",
	"format.optifine_entity.info.optifine_required": "Uživatelé bez nainstalovaného OptiFine model neuvidí.",
	"format.optifine_entity.info.pivots": "Osy otáčení částí těla jsou zamčené, je moudré se jich nedotýkat.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Jiné",
	"format_category.loaders": "Načítače",
	"message.recover_backup.recover": "Obnovit",
	"message.invalid_characters.title": "Neplatná Cesta",
	"message.invalid_characters.message": "Cesta k importovanému souboru obsahuje neplatné znaky, velká písmena nebo mezery. Podporované znaky jsou: %0",
	"dialog.share_model.thumbnail": "Miniatura",
	"dialog.skin.high_res_texture": "Upozorňujeme, že skiny s vybraným rozlišením nebudou fungovat jako běžné Minecraft skiny. Vyberte nižší rozlišení.",
	"settings.allow_display_slot_mirror": "Povolit zrcadlení slotů",
	"settings.allow_display_slot_mirror.desc": "Povolí zrcadlení slotů pro předmětové modely Java. VAROVÁNÍ: Funguje pouze pro Minecraft 1.14 nebo starší, případně ve zvláštních případech.",
	"action.switch_tabs": "Přepnout Karty",
	"action.switch_tabs.desc": "Procházejte otevřené karty. Podržte Shift pro průchod v opačném směru.",
	"action.unselect_all": "Zrušit Výběr Všeho",
	"action.save_palette": "Uložit paletu...",
	"action.save_palette.desc": "Uloží aktuální barevnou paletu v Blockbenchi ​​pro pozdější použití",
	"action.keyframe_column_create": "Vytvořit sloupec klíčových snímků",
	"action.keyframe_column_create.desc": "Zamkne všechny kanály na časové ose v aktuálním časovém kódu, pokud již obsahují klíčové snímky",
	"action.keyframe_column_select": "Vybrat sloupec klíčových snímků",
	"action.keyframe_column_select.desc": "Vybere všechny klíčové snímky na časové ose podél sloupce pod přehrávací hlavou",
	"menu.uv": "UV",
	"menu.keyframe": "Klíčové snímky",
	"menu.palette.load.update": "Aktualizovat Paletu",
	"menu.palette.load.update.desc": "Aktualizuje tuto paletu barvami aktuální palety Blockbenche",
	"menu.timeline_marker.set_time": "Nastavit Čas...",
	"uv_editor.scale_uv": "Škálovat UV",
	"action.preview_scene": "Náhled scény",
	"action.preview_scene.desc": "Změna scény náhledu modelu",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Převrátit Osu Y",
	"preview_scene.studio": "Studio",
	"format.image": "Obrázek",
	"modifier_actions.set_copy_source": "Nastavit zdroj kopie",
	"message.load_images.title": "Načíst Obrázky",
	"message.load_images.edit_image": "Upravit Obrázek",
	"dialog.add_primitive.align_edges": "Zarovnat hrany",
	"dialog.flip_animation.show_in_timeline": "Zobrazit upravené části těla na časové ose",
	"settings.default_cube_size": "Velikost Kostky",
	"settings.default_cube_size.desc": "Nastavte výchozí velikost kostky při vytváření nové kostky",
	"settings.uniform_keyframe": "Sjednotit měřítka klíčových snímků",
	"settings.uniform_keyframe.desc": "Nastaví výchozí měřítko klíčových snímků pro sjednocení měřítek",
	"settings.nearest_rectangle_select": "Obdélníkový výběr: nejbližší okraj",
	"settings.nearest_rectangle_select.desc": "Přichytí výběr obdélníku k nejbližšímu okraji pixelu, jako v GIMPu, místo přichycení k celým pixelům.",
	"settings.pick_color_opacity": "Vybrat průhlednost barvy",
	"settings.pick_color_opacity.desc": "Vybere průhlednost barvy pomocí Kapátka a nastaví jí jako průhlednost štětce",
	"settings.paint_with_stylus_only": "Malování pouze pomocí Stylus",
	"settings.paint_with_stylus_only.desc": "Stylus používejte pouze pro malování, myš nebo dotykový vstup vyhraďte pro navigaci.",
	"action.copy_brush_mode": "Kopírovat Režim Štětce",
	"action.copy_brush_mode.copy": "Kopírovat",
	"action.copy_brush_mode.pattern": "Vzor",
	"action.copy_brush_mode.sample": "Vzorek",
	"action.brush_shape": "Tvar Štětce",
	"action.brush_shape.square": "Ćtverec",
	"action.brush_shape.circle": "Kruh",
	"action.blend_mode": "Režim Prolnutí",
	"action.blend_mode.default": "Výchozí",
	"action.blend_mode.set_opacity": "Nastavit Průhlednost",
	"action.blend_mode.color": "Barva",
	"action.blend_mode.behind": "Za",
	"action.blend_mode.multiply": "Násobit",
	"action.blend_mode.divide": "Dělit",
	"action.blend_mode.add": "Přidat",
	"action.blend_mode.subtract": "Odečíst",
	"action.blend_mode.screen": "Obrazovka",
	"action.blend_mode.overlay": "Překrytí",
	"action.blend_mode.hard_light": "Tvrdé světlo",
	"action.blend_mode.difference": "Rozdíl",
	"action.copy_brush": "Kopírovat Štětec",
	"action.copy_brush.desc": "Štětcem klonuje části textury nebo kreslí vzory. Ctrl a klikem vyberete zdroj kopie.",
	"action.validator_window": "Zobrazit Problémy Modelu...",
	"action.validator_window.desc": "Otevře validátor, který zobrazuje problémy s aktuálním modelem.",
	"action.cancel_gif": "Zrušit GIF",
	"menu.text_edit.copy_vector": "Kopírovat Vektor",
	"menu.brush_presets.dialog": "Předvolby Štětce...",
	"menu.brush_presets.pixel_brush": "Pixelový Štětec",
	"menu.brush_presets.smooth_brush": "Hladký Štětec",
	"menu.texture.edit_in_blockbench": "Upravit v Blockbench",
	"menu.mirror_painting.axis": "Osa",
	"menu.mirror_painting.axis.desc": "Vybere, na které ose se budou tahy barvy zrcadlit",
	"menu.mirror_painting.global": "Globální Symetrie",
	"menu.mirror_painting.global.desc": "Povolí zrcadlové malování modelu v globálním prostoru",
	"menu.mirror_painting.local": "Lokální symetrie",
	"menu.mirror_painting.local.desc": "Povolí zrcadlové malování v lokálním prostoru pro každý prvek",
	"menu.mirror_painting.texture_frames": "Opakovat na rámech Flipbooku",
	"menu.mirror_painting.texture_frames.desc": "Zrcadlí tahy barvy do každého snímku animovaných textur",
	"format.bedrock_block.info.size_limit": "Celková velikost bloku je omezena na 30 pixelů ve všech rozměrech. Limit může být mimo střed ve všech směrech o 7 pixelů od středu bloku.",
	"format.bedrock_block.info.textures": "V Blockbenchi ​​lze na různé kostky aplikovat více textur, ale pro správnou funkci ve hře je vyžadováno další nastavení v behavior packu.",
	"format.image.desc": "Upravit obrázky v 2D editoru obrázků",
	"generic.delete_all": "Smazat Vše",
	"message.child_model_only.open": "Otevřít Nadřazený",
	"message.child_model_only.open_with_textures": "Otevřít Nadřazený a Převzít Textury",
	"dialog.project.credit": "Autoři",
	"dialog.convert_project.create_copy": "Vytvořit Kopii",
	"dialog.texture.frame_time": "Doba Snímku",
	"dialog.texture.frame_time.desc": "Nastavte, jak dlouho bude každý snímek viditelný, v ticks. Jeden tick = 1/20 sekundy.",
	"dialog.texture.frame_interpolate": "Interpolovat",
	"dialog.texture.frame_interpolate.desc": "Interpolujte mezi snímky animace pomocí prolínání do dalšího snímku",
	"dialog.texture.frame_order_type": "Režim Smyčky",
	"dialog.texture.frame_order_type.loop": "Smyčka",
	"dialog.texture.frame_order_type.backwards": "Smyčka Pozpátku",
	"dialog.texture.frame_order_type.back_and_forth": "Tam-a-Zpět",
	"dialog.texture.frame_order_type.custom": "Vlastní Pořadí",
	"dialog.texture.frame_order": "Pořadí Snímků",
	"dialog.texture.frame_order.desc": "Nastaví vlastní pořadí snímků seřazením indexů snímků v novém pořadí. Indexy snímků začínají prvním snímkem na nule.",
	"dialog.select.mode": "Režim",
	"dialog.select.mode.new": "Nový Výběr",
	"dialog.select.mode.add": "Přidat k Vybranému",
	"dialog.select.mode.remove": "Odebrat z Vybraného",
	"dialog.select.mode.in_selection": "Vybrat pouze z Vybraného",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Predikáty",
	"dialog.predicate_overrides.variants": "Varianty",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Přidat Přepsání",
	"dialog.predicate_overrides.add_predicate": "Přidat Predikát",
	"dialog.predicate_overrides.generate_overrides": "Vygenerovat Přepsání",
	"dialog.predicate_overrides.confirm_delete": "Opravdu chcete smazat všechna přepsání?",
	"dialog.predicate_overrides.predicate.angle": "Úhel Kompasu",
	"dialog.predicate_overrides.predicate.blocking": "Blokuje",
	"dialog.predicate_overrides.predicate.broken": "Je rozbité",
	"dialog.predicate_overrides.predicate.cast": "Je obsazeno",
	"dialog.predicate_overrides.predicate.cooldown": "Doba Obnovy",
	"dialog.predicate_overrides.predicate.damage": "Poškození",
	"dialog.predicate_overrides.predicate.damaged": "Je Poškozený",
	"dialog.predicate_overrides.predicate.lefthanded": "Je Levák",
	"dialog.predicate_overrides.predicate.pull": "Síla tahu",
	"dialog.predicate_overrides.predicate.pulling": "Tahá",
	"dialog.predicate_overrides.predicate.charged": "Je nabito",
	"dialog.predicate_overrides.predicate.firework": "Má Ohňostroj",
	"dialog.predicate_overrides.predicate.throwing": "Připraveno k hodu",
	"dialog.predicate_overrides.predicate.time": "Čas Dne",
	"dialog.predicate_overrides.predicate.custom_model_data": "Vlastní Data Modelu",
	"dialog.predicate_overrides.predicate.level": "Úroveň Světla",
	"dialog.predicate_overrides.predicate.filled": "Úroveň naplnění svazku",
	"dialog.predicate_overrides.predicate.tooting": "Troubení",
	"settings.model_export_scale": "Měřítko exportu modelu",
	"settings.model_export_scale.desc": "Faktor, o který se zmenší měřítko exportovaných modelů glTF, DAE a FBX. Výchozí hodnota je 16, což v exportu převede 16 Blockbench jednotek na 1 metr.",
	"action.export_fbx": "Exportovat FBX Model",
	"action.export_fbx.desc": "Export modelu a animací jako soubor FBX pro použití v jiných 3D aplikacích a herních enginech",
	"action.center_lateral": "Vycentrovat Laterálně",
	"action.center_lateral.desc": "Vycentrovat vybrané prvky podle os X a Z",
	"action.adjust_opacity": "Upravit Průhlednost...",
	"action.adjust_opacity.desc": "Upravte průhlednost vybrané textury",
	"action.rotate_texture_cw": "Otočit po směru hodin",
	"action.rotate_texture_ccw": "Otočit proti směru hodin",
	"action.predicate_overrides": "Upravit přepsání predikátů...",
	"action.predicate_overrides.desc": "Vybere modely pro přepis vybraného modelu na základě vybraných podmínek",
	"action.auto_set_cullfaces": "Automaticky nastavit Dotykové vynechání",
	"action.auto_set_cullfaces.desc": "Automaticky generuje obrysy pro skrytí ploch, pokud jsou zakryté sousedním blokem.",
	"menu.texture.edit_externally": "Upravit Externě",
	"menu.mirror_painting.texture": "2D Editor Symetrie",
	"menu.mirror_painting.texture.desc": "Povolí zrcadlové malování ve 2D prostoru na obrázku nebo textuře",
	"menu.animator.rotation_global": "Otočit v globálním prostoru",
	"uv_editor.face_properties": "Vlastnosti Plochy",
	"uv_editor.face_properties.material_instance": "Instance Materiálu",
	"uv_editor.tint.info": "Na ploše lze povolit tónování, aby Minecraft aplikoval barvu. Ve vanille lze tónování použít pouze u specifických bloků, jako jsou listy, redstone prach, a může mít hodnotu pouze 0.",
	"uv_editor.cullface.info": "Povolení funkce Dotykové vynechání ovlivní plochu na bloku tak, aby se nevykreslila, pokud je v Minecraft světě vedle ní a v daném směru umístěn další celý blok. To lze využít k optimalizaci výkonu.",
	"uv_editor.material_instance.info": "Instance materiálů lze nastavit na uživatelem definovaný název. Tento název lze použít v blokovém JSON souboru v behavior packu k přiřazení konkrétní textury a materiálu, který bude daná plocha mít.",
	"display.reference.frame_invisible": "Rámeček na Předmět (neviditelný)",
	"data.settings_profile": "Profil",
	"message.display_skin.invalid_name": "Nelze najít Minecraft účet jménem \"%0\".",
	"dialog.load_plugins_from_query.title": "Načíst Pluginy",
	"dialog.load_plugins_from_query.text": "Použili jste odkaz, který vyžaduje pluginy. Přejete si je nainstalovat?",
	"dialog.select_model.title": "Vybrat Model",
	"dialog.select_model.bones": "Části Těla",
	"dialog.select_model.cubes": "Kostky",
	"dialog.settings.create_profile": "Vytvořit Profil...",
	"settings_profile.confirm_delete": "Opravdu chcete smazat tento profil nastavení?",
	"settings_profile.condition.type.selectable": "Ručne Volitelné",
	"settings.interface_mode": "Režim UI",
	"settings.interface_mode.desc": "Režim rozhraní",
	"settings.interface_mode.auto": "Automaticky",
	"settings.interface_mode.desktop": "Plocha",
	"settings.interface_mode.mobile": "Mobil",
	"settings.paint_through_transparency": "Malovat Přes Průhlednost",
	"settings.paint_through_transparency.desc": "Umožní malování přes průhledné pixely, když je možnost Zamknout alfa kanál povolena",
	"action.tab_overview": "Přehled Karet",
	"action.tab_overview.desc": "Zobrazí všechny otevřené karty v mřížce a přejde na jednu z nich",
	"action.slider_color_red": "Červená",
	"action.slider_color_green": "Zelená",
	"action.slider_color_blue": "Modrá",
	"action.add_animation_controller": "Přidat ovladač animace",
	"action.add_animation_controller.desc": "Vytvoří prázdný ovladač animace",
	"action.animation_controller_preview_mode": "Náhled ovladače",
	"action.animation_controller_preview_mode.paused": "Pozastaveno",
	"action.animation_controller_preview_mode.manual": "Ruční náhled",
	"action.animation_controller_preview_mode.play": "Auto Přehrávání",
	"action.keyframe_interpolation.bezier": "Bézierova křivka",
	"action.keyframe_bezier_linked": "Přichytit úchyty beziérovy křivky",
	"action.keyframe_bezier_linked.desc": "Spojí pravý a levý úchyt beziérova klíčového snímku",
	"action.reset_keyframe_handles": "Obnovit úchyty klíčových snímků",
	"action.reset_keyframe_handles.desc": "Resetuje úchyty beziérovy křivky u vybraných klíčových snímků",
	"action.looped_animation_playback": "Přehrávání ve smyčce",
	"action.looped_animation_playback.desc": "Náhled animací v nekonečné smyčce",
	"timeline.bind_to_actor": "Vázat k herci",
	"animation_controllers.select_preset": "Vyberte předvolbu ovladače...",
	"animation_controllers.state.animations": "Animace",
	"animation_controllers.state.particles": "Částice",
	"animation_controllers.state.sounds": "Zvuky",
	"animation_controllers.state.on_entry": "Při Vstupu",
	"animation_controllers.state.on_exit": "Při Odchodu",
	"animation_controllers.state.transitions": "Přechody",
	"animation_controllers.state.condition": "Podmínka",
	"animation_controllers.state.blend_transition": "Doba Prolínání",
	"animation_controllers.state.shortest_path": "Prolnutí dle nejkratší cesty",
	"animation_controllers.state.edit_transition": "Upravit Přechod",
	"menu.color_picker.picker_type": "Typ sběrače",
	"menu.color_picker.picker_type.square": "Čtverec",
	"menu.color_picker.picker_type.wheel": "Kolo",
	"menu.color_picker.slider_mode": "Režim posunutí",
	"menu.color_picker.slider_mode.hsv": "Odstín, Sytost, Jas",
	"menu.color_picker.slider_mode.rgb": "Červená, Zelená, Modrá",
	"menu.texture.render_mode.additive": "Přídavný",
	"panel.color.picker_options": "Možnosti Výběru Barvy",
	"panel.animation_controllers": "Ovladač Animace",
	"display.preset.armor_stand": "Pozemní (stojan na brnění)",
	"data.file_path": "Cesta k Souboru",
	"dialog.extrude.orientation": "Orientace",
	"dialog.extrude.orientation.upright": "Svislý",
	"dialog.extrude.orientation.flat": "Plochý",
	"dialog.scale.box_uv_warning": "Změna měřítka Box UV modelu může narušit UV. Zkuste model škálovat externě, nebo přepněte do režimu UV pro jednotlivé plochy v nabídce Soubor > Projekt.",
	"dialog.create_gif.format": "Formát",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Sekvence PNG",
	"dialog.create_gif.pixelate": "Pixelovat",
	"dialog.create_gif.bg_image": "Obrázek Pozadí",
	"dialog.create_gif.turn.desc": "Otočí model během nahrávání. Použije záporné hodnoty pro otáčení modelu ve směru hodin. Hodnota 60 odpovídá jedné otáčce každou sekundu.",
	"settings_profile.condition": "Podmínka",
	"settings_profile.condition.type.file_path.desc": "Použije syntaxi regulárních výrazů pro nalezení shody s cestou k souboru aktuálního projektu. Pro adresáře použijte lomítka.",
	"settings.only_selected_bezier_handles": "Zobrazit pouze vybrané bézierovy úchyty",
	"settings.only_selected_bezier_handles.desc": "Shová úchyty beziérových klíčových snímků",
	"settings.embed_textures": "Vložené textury",
	"settings.embed_textures.desc": "Vloží soubor textury do souborů .bbmodel",
	"action.selection_mode.cluster": "Shluk",
	"dialog.copied_to_clipboard": "Zkopírováno do schránky",
	"data.reference_image": "Referenční Obrázek",
	"message.delete_reference_image": "Opravdu chcete smazat tento referenční obrázek? Tuto akci nelze vrátit zpět.",
	"message.add_reference_image.message": "Vyberte, odkud načíst referenční obrázek",
	"message.add_reference_image.project": "Přidat do tohoto projektu",
	"message.add_reference_image.app": "Přidat do všech projektů",
	"message.import_particle_texture.import": "Importovat Texturu Částice",
	"message.import_particle_texture.message": "Chcete importovat texturu pro částice?",
	"message.save_codec_selector.title": "Uložit Formát Modelu",
	"message.save_codec_selector.message": "Vyberte formát pro uložení modelu.",
	"message.save_codec_selector.project_file": "Blockbench Projekt (.bbmodel)",
	"message.save_codec_selector.both": "Oba",
	"message.display_skin.username": "Uživatelské jméno (Java)",
	"message.palette_locked": "Paleta je uzamčena",
	"dialog.project.default_uv_mode": "Výchozí režim UV",
	"dialog.project.default_uv_mode.description": "Výchozí UV režim projektu. UV režim lze také změnit pro každou kostku.",
	"dialog.export_options.title": "Možnosti Exportu",
	"dialog.edit_texture.preview": "Náhled",
	"dialog.proportional_editing.range": "Rozsah",
	"dialog.proportional_editing.falloff": "Útlum",
	"dialog.proportional_editing.falloff.linear": "Lineární",
	"dialog.proportional_editing.falloff.hermite_spline": "Hladké",
	"dialog.proportional_editing.falloff.constant": "Konstantní",
	"dialog.proportional_editing.selection": "Výběr",
	"dialog.proportional_editing.selection.linear": "Lineární Vzdálenost",
	"dialog.proportional_editing.selection.connections": "Spojení",
	"dialog.mirror_painting_texture_center.middle": "Střed",
	"dialog.mirror_painting_texture_center.custom": "Vlastní",
	"dialog.settings.reset_to_default": "Obnovit Výchozí Nastavení",
	"keybindings.item.num_slider.increase": "Zvýšit",
	"keybindings.item.num_slider.decrease": "Snížit",
	"settings.always_show_splash_art": "Vždy Zobrazovat Uvítací Grafiku",
	"settings.always_show_splash_art.desc": "Vždy zobrazovat uvítací grafiku na úvodní obrazovce",
	"action.slider_palette_color": "Přepnout Barvu Palety",
	"action.slider_palette_color.desc": "Procházet barvy v paletě",
	"action.proportional_editing": "Proporcionální úpravy",
	"action.proportional_editing.desc": "Úměrně ovlivní okolní vrcholy při úpravě částí sítě",
	"action.limit_to_palette": "Omezit na Paletu",
	"action.limit_to_palette.desc": "Omezí barvy textury na ty v aktuálně načtené paletě",
	"action.edit_reference_images": "Upravit Referenční Obrázky",
	"action.edit_reference_images.desc": "Zapne režim referenčních obrázků pro přidávání nebo úpravu referenčních obrázků a plánů",
	"action.add_reference_image": "Přidat Referenční Obrázek",
	"action.reference_image_from_clipboard": "Referenční Obrázek ze Schránky",
	"action.reference_image_list": "Referenční Obrázky",
	"action.connect_uv_faces": "Propojit UV Plochy",
	"action.connect_uv_faces.desc": "Propojí vybrané UV plochy s poslední vybranou UV plochou",
	"action.merge_uv_vertices": "Sloučit UV Vrcholy",
	"action.merge_uv_vertices.desc": "Přichytí první vybrané UV vrcholy k posledním vybraným UV vrcholům",
	"action.bedrock_animation_mode": "Režim Animací Bedrock",
	"action.bedrock_animation_mode.desc": "Vyberte režim pro úpravu animací pro Minecraft: Bedrock Edition v",
	"action.bedrock_animation_mode.entity": "Entita",
	"action.bedrock_animation_mode.attachable_first": "Předmět První Osoba",
	"action.bedrock_animation_mode.attachable_third": "Předmět Třetí Osoba",
	"timeline.amplify": "Zesílit",
	"menu.options": "Možnosti...",
	"menu.palette.lock_palette": "Uzamknout Paletu",
	"menu.uv.export": "Exportovat UV Mapu",
	"menu.uv.flip_x": "Zrcadlit X",
	"menu.uv.flip_y": "Zrcadlit Y",
	"menu.mirror_painting.enabled": "Povoleno",
	"reference_image.position": "Pozice",
	"reference_image.size": "Velikost",
	"reference_image.rotation": "Rotace",
	"reference_image.opacity": "Průhlednost",
	"reference_image.visibility": "Viditelnost",
	"reference_image.clear_mode": "Režim Vymazání",
	"reference_image.layer": "Vrstva",
	"reference_image.layer.background": "Za Modelem",
	"reference_image.layer.viewport": "Nad Modelem",
	"reference_image.layer.float": "Nad Rozhraním",
	"reference_image.scope": "Rozsah",
	"reference_image.scope.project": "Pouze tento projekt",
	"reference_image.scope.global": "Všechny projekty",
	"reference_image.enabled_modes": "Povoleno v modech",
	"codec.common.encoding": "Kódování",
	"codec.common.armature": "Exportovat skupiny jako armaturu",
	"codec.common.export_animations": "Exportovat Animace",
	"codec.common.embed_textures": "Vložené textury",
	"preview.center_camera": "Vycentrovat Kameru",
	"display.reference.frame_top": "Rámeček vršek",
	"display.reference.frame_top_invisible": "Rámeček vršek (neviditelný)",
	"action.proportional_editing_range": "Rozsah proporcionální úpravy",
	"action.proportional_editing_range.desc": "Upraví rozsah pro proporcionální úpravy",
	"action.toggle_all_reference_images": "Skrýt/Zobrazit všechny referenční obrázky",
	"action.toggle_all_reference_images.desc": "Přepnout najednou viditelnost všech referenčních obrázků",
	"action.add_animation_controller_state": "Přidat stav ovladače animace",
	"action.add_animation_controller_state.desc": "Přidání nového stavu do ovladače animace",
	"menu.slider.round_value": "Zaokrouhlit Hodnotu",
	"texture.error.too_large": "Rozlišení překračuje maximum %0",
	"dialog.copy_to_clipboard": "Kopírovat do schránky",
	"dialog.open_url": "Otevřít URL",
	"reference_image.image": "Obrázek",
	"uv_editor.rotate_uv": "Otočiť UV",
	"generic.error": "Chyba",
	"projects.start_screen": "Úvodní Obrazovka",
	"message.invalid_link.message": "Sdílený model „%0“, který se pokoušíte načíst, je neplatný nebo vypršel.",
	"message.plugin_dependencies.title": "Závislosti Pluginu",
	"message.plugin_dependencies.message1": "Plugin vyžaduje tyto závislosti:",
	"message.plugin_dependencies.message1_update": "Plugin %0 byl aktualizován a nyní vyžaduje tyto závislosti:",
	"message.plugin_dependencies.message2": "Chcete je nainstalovat pro pokračování?",
	"message.plugin_dependencies.invalid": "Plugin bohužel nelze nainstalovat, má neplatnou závislost:",
	"message.preview_scene_load_failed": "Nepodařilo se načíst náhled scény. Zkontrolujte své internetové připojení.",
	"dialog.convert_project.text1": "Převeďte projekt do jiného formátu.",
	"dialog.convert_project.text2": "Použijte převod na vlastní riziko. Formáty mají různé funkce a omezení, takže převod může v některých případech poškodit části vašeho projektu.",
	"dialog.convert_project.text3": "Převod nelze vrátit zpět, proto se ve výchozím nastavení vytvoří kopie.",
	"dialog.unsaved_work.title": "Neuložená Práce",
	"dialog.unsaved_work.text": "Následující projekty obsahují neuložené změny. Chcete je uložit?",
	"dialog.unsaved_work.discard_all": "Zahodit Vše",
	"dialog.unsaved_work.save_all": "Uložit Vše",
	"dialog.resize_texture.mode": "Režim",
	"dialog.resize_texture.mode.crop": "Oříznout/Rozšířit",
	"dialog.resize_texture.mode.scale": "Škálovat",
	"dialog.plugins.is_installed": "Nainstalováno",
	"dialog.plugins.is_disabled": "Zakázáno",
	"dialog.plugins.disable": "Zakázat",
	"dialog.plugins.enable": "Povolit",
	"dialog.plugins.dependencies": "Závisí na:",
	"dialog.view_backups.open_folder": "Otevřít složku",
	"dialog.share_model.reference_images": "Zahrnout Referenční Obrázky",
	"dialog.share_model.too_large": "Nahrání selhalo: Model je příliš velký",
	"dialog.share_model.too_large_references": "Nahrání selhalo: Model je příliš velký. Zkuste bez referenčních obrázků.",
	"settings.stretch_linked": "Protahování odkazů",
	"settings.stretch_linked.desc": "Roztáhne kostku ve všech směrech stejnou hodnotou",
	"settings.grids": "Zobrazit Mřížky",
	"settings.grids.desc": "Zobrazit nebo skrýt všechny 3D mřížky",
	"settings.double_click_switch_tools": "Přepínání nástrojů dvojitým klikem",
	"settings.double_click_switch_tools.desc": "Dvojitým klikem na zobrazení přepnete mezi nástroji",
	"settings.outlines_in_paint_mode": "Obrysy výběru v Režimu malování",
	"settings.outlines_in_paint_mode.desc": "Zobrazí obrysy výběru prvků v režimu kreslení",
	"settings.json_indentation": "Odsazení JSON",
	"settings.json_indentation.desc": "Styl odsazení pro exportované JSON soubory",
	"settings.json_indentation.tabs": "Karty",
	"settings.json_indentation.spaces_4": "Mezery: 4",
	"settings.json_indentation.spaces_2": "Mezery: 2",
	"action.slider_stretch": "Protažení",
	"action.slider_stretch.desc": "Multiplikativně roztáhne krychle na ose %0 bez změny UV",
	"action.view_backups": "Zobrazit zálohy",
	"action.view_backups.desc": "Procházení seznamu automaticky uložených záloh projektů",
	"action.search_outliner": "Prohledání osnovy",
	"action.search_outliner.desc": "Prohledá konkrétní názvy prvků v osnově",
	"action.mirror_modeling": "Zrcadlové Modelování",
	"action.mirror_modeling.desc": "Povolte zrcadlové modelování na ose X. Všechny změny provedené v zobrazení se projeví na druhé straně, pokud nejsou u daného prvku výslovně zakázány.",
	"action.allow_element_mirror_modeling": "Povolit Zrcadlové Modelování",
	"action.allow_element_mirror_modeling.desc": "Vybere, zda lze vybrané prvky ovlivnit zrcadlovým modelováním",
	"action.switch_face_crease": "Přepnutí záhybu plochy",
	"action.switch_face_crease.desc": "Přepnout, kterým směrem se čtyřúhelník láme uprostřed",
	"action.clear_unused_texture_space": "Vymazat nevyužitý prostor textury",
	"action.clear_unused_texture_space.desc": "Vyčistí části textury, které nejsou UV mapovány na žádné prvky",
	"action.split_screen": "Rozdělená Obrazovka",
	"action.split_screen.desc": "Vyberte režim zobrazení obrazovky",
	"action.split_screen.single": "Jedno Okno",
	"action.split_screen.double_horizontal": "Dvě Okna Horizontálně",
	"action.split_screen.double_vertical": "Dvě Okna Vertikálně",
	"action.split_screen.quad": "Čtyři Okna",
	"action.split_screen.triple_left": "Tři Okna Vlevo",
	"action.split_screen.triple_right": "Tři Okna Vpravo",
	"action.split_screen.triple_top": "Tři Okna Nahoře",
	"action.split_screen.triple_bottom": "Tři Okna Dole",
	"action.uv_project_from_view": "UV projekt z pohledu",
	"action.uv_project_from_view.desc": "Automaticky generuje UV pro vybrané plochy z 3D pohledu",
	"action.graph_editor_other_graphs": "Zobrazit Ostatní Grafy",
	"action.graph_editor_other_graphs.desc": "Určuje, zda se zobrazují grafy nevybraných os",
	"action.graph_editor_include_other_graphs": "Zahrnout Ostatní Grafy",
	"action.graph_editor_include_other_graphs.desc": "Pokud grafický editor zahrnuje i grafy, které nejsou v zobrazení vybrány",
	"action.set_ik_source": "Nastavit kořen IK",
	"action.set_ik_source.desc": "Vybere kořenovou část těla z řetězu, kterým má tento nulový objekt pohnout pomocí inverzní kinematiky",
	"edit.loop_cut.cuts": "Řezy",
	"panel.element.stretch": "Protažení",
	"preview_scene.minecraft_plains": "Pláň",
	"preview_scene.minecraft_cherry_grove": "Třešňový Háj",
	"preview_scene.minecraft_snowy_tundra": "Sněžná Tundra",
	"preview_scene.minecraft_sunset": "Západ Slunce",
	"preview_scene.minecraft_night": "Noc",
	"preview_scene.minecraft_desert": "Poušť",
	"preview_scene.minecraft_underwater": "Pod Vodou",
	"preview_scene.minecraft_coral_reef": "Korálový Útes",
	"preview_scene.minecraft_lush_cave": "Bujná Jeskyně",
	"preview_scene.minecraft_deep_dark": "Hluboká Tma",
	"generic.navigate_forward": "Vpřed",
	"generic.navigate_back": "Zpět",
	"action.element_render_order": "Pořadí Vykreslovaní Průhlednosti",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Za",
	"action.element_render_order.in_front": "Před",
	"message.installing_update.title": "Dostupná aktualizace",
	"message.installing_update.message": "Je připravena nová verze k instalaci. Po zavření aplikace čekejte přibližně %0 sekund, než opět otevřete Blockbench nebo vypnete počítač, aby se aktualizace nainstalovala.",
	"settings.brush_cursor_2d": "Kurzor 2D Štětce",
	"settings.brush_cursor_2d.desc": "Zobrazí obrys štětce ve 2D pracovním prostoru",
	"settings.brush_cursor_3d": "Kurzor 3D Štětce",
	"settings.brush_cursor_3d.desc": "Zobrazí obrys štětce ve 3D pracovním prostoru",
	"settings.cdn_mirror": "Použít CDN Mirror",
	"settings.cdn_mirror.desc": "Pro stahování pluginů použijte CDN Mirror. Přijímá aktualizace rychleji a funguje v některých oblastech, kde výchozí nastavení nefunguje.",
	"data.layer": "Vrstva",
	"data.panel": "Panel",
	"generic.confirm_delete": "Opravdu to chcete smazat?",
	"format_category.general": "Obecné",
	"modifier_actions.no_uniform_scaling": "Volné škálování",
	"message.texture_refresh_conflict.title": "Konfliktní verze textur",
	"message.texture_refresh_conflict.message": "Soubor textury může obsahovat změny, které jsou v konfliktu s verzí Blockbenche",
	"message.texture_refresh_conflict.keep_ours": "Ponechat Verzi z Blockbenche",
	"message.texture_refresh_conflict.keep_theirs": "Načte soubor a zahodí všechny změny a vrstvy v Blockbenchi",
	"message.group_required_to_animate": "Tento typ prvku nelze animovat. Vytvořte skupinu nebo armaturu pro jeho animaci.",
	"dialog.texture.uv_size": "Velikost UV",
	"dialog.advanced_screenshot.angle_preset": "Přednastavení úhlu",
	"dialog.advanced_screenshot.resolution": "Rozlišení",
	"dialog.advanced_screenshot.zoom_to_fit": "Přizpůsobit oknu",
	"dialog.advanced_screenshot.zoom": "Zoom / Ohnisková vzdálenost",
	"dialog.advanced_screenshot.anti_aliasing": "Vyhlazování-hran",
	"dialog.advanced_screenshot.anti_aliasing.off": "Vypnuto",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multivzorkování",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supervzorkování",
	"dialog.advanced_screenshot.show_gizmos": "Zobrazit manipulátory",
	"dialog.advanced_screenshot.shading": "Stínování",
	"settings.auto_keyframe": "Automatické klíčové snímky",
	"settings.auto_keyframe.desc": "Automaticky vytvoří klíčový snímek s výchozími hodnotami na začátku časové osy při pozdější transformaci části těla",
	"settings.modded_entity_integer_size": "Rozsah hodnot módované entity",
	"settings.modded_entity_integer_size.desc": "Omezí velikosti krychlí ve formátu Módovaná entita na celá čísla. I když jsou čísla s plovoucí čárkou v některých verzích technicky podporována, celá čísla se mnohem snáze mapují pomocí UV.",
	"category.layers": "Vrstvy",
	"keybind.paint_secondary_color": "Malovat Sekundární Barvou",
	"action.selection_tool_operation_mode": "Režim Výběru",
	"action.selection_tool_operation_mode.create": "Nový Výběr",
	"action.selection_tool_operation_mode.add": "Přidat k Výběru",
	"action.selection_tool_operation_mode.subtract": "Odebrat z Výběru",
	"action.selection_tool_operation_mode.intersect": "Průnik",
	"action.pixel_perfect_drawing": "Pixelově přesné kreslení",
	"action.pixel_perfect_drawing.desc": "Umožní hladké pixelové čáry bez dvojitých pixelů na křivkách",
	"action.selection_tool": "Nástroj pro Výběr",
	"action.selection_tool.desc": "Vyberte části obrázku",
	"action.selection_tool.rectangle": "Obdélník",
	"action.selection_tool.ellipse": "Elipsa",
	"action.selection_tool.lasso": "Výběr lasem",
	"action.selection_tool.wand": "Kouzelná Hůl",
	"action.selection_tool.color": "Stejná Barva",
	"action.move_layer_tool": "Přesunout Vrstvu",
	"action.move_layer_tool.desc": "Přesune aktuální vrstvu nebo výběr",
	"action.export_modded_animations": "Export animací módovaných entit",
	"action.export_modded_animations.desc": "Exportovat animace pro model modifikované entity v Minecraft Java Edici",
	"action.swap_colors": "Prohodit Barvy",
	"action.swap_colors.desc": "Prohodí hlavní a vedlejší barvu",
	"action.apply_mesh_rotation": "Použít rotaci",
	"action.apply_mesh_rotation.desc": "Resetuje rotaci prvku sítě a místo toho ji aplikuje na geometrii",
	"action.flip_texture_x.desc": "Obrátit texturu nebo vrstvu horizontálně",
	"action.flip_texture_y.desc": "Obrátit texturu nebo vrstvu vertikálně",
	"action.rotate_texture_cw.desc": "Otočit texturu nebo vrstvu po směru hodin",
	"action.rotate_texture_ccw.desc": "Otočit texturu nebo vrstvu proti směru hodin",
	"action.crop_texture_to_selection": "Oříznout Texturu podle Výběru",
	"action.create_empty_layer": "Vytvořit Prázdnou Vrstvu",
	"action.enable_texture_layers": "Povolit Vrstvy",
	"action.disable_texture_layers": "Zakázat Vrstvy",
	"action.layer_opacity": "Průhlednost Vrstvy",
	"action.layer_to_texture_size": "Rozšířit Vrstvu na Velikost Textury",
	"action.layer_to_texture_size.desc": "Rozšíří vrstvu na velikost textury",
	"action.merge_layer_down": "Sloučit Dolů",
	"action.merge_layer_down.desc": "Sloučí do vrstvy pod ní",
	"action.advanced_screenshot": "Pokročilý Snímek Obrazovky...",
	"action.advanced_screenshot.desc": "Snímek obrazovky modelu s pokročilými možnostmi",
	"action.bake_ik_animation": "Implementovat inverzní kinematiku",
	"action.bake_ik_animation.desc": "Implementuje rotace aplikované inverzní kinematikou do vybrané animace",
	"action.save_animation_preset": "Uložit přednastavení animace...",
	"action.save_animation_preset.desc": "Uloží vybrané klíčové snímky jako přednastavení animace",
	"action.animation_onion_skin": "Animace cibulového vrstvení",
	"action.animation_onion_skin.desc": "Zobrazí drátový model jiného snímku v animaci pro referenci",
	"action.apply_animation_preset": "Použít přednastavení animace",
	"action.apply_animation_preset.desc": "Vyberte ze seznamu přednastavení animací a aplikujte na vybranou část těla",
	"menu.brush_presets.pixel_perfect": "Pixelově-přesný Štětec",
	"panel.layers": "Vrstvy",
	"uv_editor.copy_paste_tool.to_layer": "Do Nové Vrstvy",
	"format.image.new": "Vytvořit Nový Obrázek",
	"format.image.info.summary": "Editor 2D obrázků umožňuje vytvářet a upravovat obrázky a pixelové grafiky přímo v Blockbenchi bez nutnosti jiného editoru obrázků. Upravujte/Vytvářejte obrázky, textury nebo pixelové grafiky!",
	"settings.move_with_selection_tool": "Použití nástroje pro výběr k přesunutí výběrů",
	"settings.move_with_selection_tool.desc": "Umožní nástroji pro výběr přímo přesouvat výběry, bez potřeby přepínat na nástroj pro přesun vrstvy",
	"settings.final_newline": "Závěrečný newline",
	"settings.final_newline.desc": "Vloží znak nového řádku na konec exportovaných souborů",
	"action.crop_layer_to_selection": "Oříznout vrstvu do výběru",
	"action.edit_mode_uv_overlay.desc": "Zobrazit UV mapu jako překrytí v režimu úprav",
	"menu.image": "Obrázek",
	"menu.texture.discard_changes": "Zahodit Změny",
	"menu.texture.discard_changes.desc": "Zahodí všechny neuložené změny a načte nejnovější verzi ze souboru",
	"panel.textures.images": "Obrázky",
	"dialog.advanced": "Pokročilé",
	"dialog.recommended_option": "doporučené",
	"modifier_actions.snap_to_center": "Přichytit ke Středu",
	"modifier_actions.snap_to_pixels": "Přichytit na Pixely",
	"message.invalid_format.install_plugin": "Nainstalovat plugin '%0'",
	"message.plugin_deprecated.message": "Opravdu chcete nainstalovat tento zastaralý plugin?",
	"message.plugin_deprecated.install_anyway": "Nainstalovat i tak",
	"message.image_editor.not_found": "Nepodařilo se najít vybraný editor obrázků. Vyberte prosím jinou možnost.",
	"message.knife_tool.confirm": "Stiskněte %0 nebo klikněte sem pro Nůž",
	"message.knife_tool.skipped_face": "Nelze řezat mezi různými plochami. Zahrňte hrany nebo vrcholy mezi nimi!",
	"message.optimize_animation.keyframes_removed": "Odebráno %0 nadbytečných klíčových snímků",
	"message.optimize_animation.nothing_to_optimize": "Nebylo co optimalizovat!",
	"message.duplicate_bone_copy_animation.title": "Kopírovat Animaci",
	"message.duplicate_bone_copy_animation.message": "Duplikovaná kost je animována v %0 animacích. Chcete zkopírovat klíčové snímky do nové části těla?",
	"message.auto_fix_mesh_edit.title": "Automatická oprava",
	"message.auto_fix_mesh_edit.revert": "Vrátit úpravy",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Některé vrcholy byly přesunuty na stejné místo. Jak chcete pokračovat?",
	"message.auto_fix_mesh_edit.concave_quads": "Jedna nebo více ploch čtyřúhelníku je vydutá, to může působit problémy při UV mapování a renderování. Blockbench to může opravit za vás:",
	"message.auto_fix_mesh_edit.merge_vertices": "Sloučit vrcholy",
	"message.auto_fix_mesh_edit.split_quads": "Rozdělit čtyřúhelníky",
	"message.load_images.add_image": "Přidat Obrázek",
	"dialog.project.modded_entity_entity_class": "Třída Entity",
	"dialog.resize_texture.offset": "Posun",
	"dialog.animated_texture_editor.code_reference": "Odkaz na Kód",
	"dialog.animated_texture_editor.code_reference.about": "Tento kód pro implementaci animace textury byl vygenerován jako reference a nemusí nutně fungovat bez úprav. Pro více informací si prostudujte dokumentaci.",
	"dialog.animated_texture_editor.code_reference.docs": "Dokumentace",
	"dialog.animated_texture_editor.reframe": "Přerámovat",
	"dialog.animated_texture_editor.stride": "Velikost Snímku",
	"dialog.animated_texture_editor.frames": "Počet Snímků",
	"dialog.animated_texture_editor.add_frame": "Přidat Snímek",
	"dialog.animated_texture_editor.resize_frames": "Změna Snímků...",
	"dialog.animated_texture_editor.apply": "Použít",
	"dialog.add_primitive.edge_size": "Velikost Hran",
	"dialog.change_animation_speed.speed": "Rychlost",
	"dialog.change_animation_speed.adjust_snapping": "Výběr",
	"dialog.optimize_animation.selection": "Výběr",
	"dialog.optimize_animation.selection.selected_keyframes": "Vybrané klíčové snímky",
	"dialog.optimize_animation.selection.selected_animation": "Vybraná Animace",
	"dialog.optimize_animation.selection.all_animations": "Všechny Animace",
	"dialog.optimize_animation.thresholds": "Prahové Hodnoty",
	"dialog.import_obj.obj": "Soubor OBJ",
	"dialog.import_obj.mtl": "Soubor MTL",
	"dialog.import_obj.scale": "Měřítko",
	"layout.thumbnail": "Vlastní CSS Miniatury",
	"settings.pixel_grid": "Mřížka Pixelů",
	"settings.pixel_grid.desc": "Zobrazit mřížku pixelů textury na prvcích v režimu úprav",
	"settings.image_editor_grid_size": "Velikost mřížky v editoru obrázků",
	"settings.image_editor_grid_size.desc": "Velikost velké mřížky v 2D editoru obrázků",
	"settings.ground_plane_double_side": "Oboustranná zemnící rovina",
	"settings.ground_plane_double_side.desc": "Zviditelnění zespodu zemnící rovinu",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export vybrané textury",
	"settings.optifine_save_default_texture.desc": "Exportovat vybranou texturu jako výchozí texturu modelu",
	"action.slider_color_select_threshold": "Prahová Hodnota Výběru Barvy",
	"action.slider_color_select_threshold.desc": "Jak blízko musí být barva sousedního pixelu, aby byl vybrán barvou nebo výběrem hůlkou",
	"action.stretch_tool": "Protažení",
	"action.stretch_tool.desc": "Nástroj pro výběr a protažení prvků",
	"action.knife_tool": "Nůž",
	"action.knife_tool.desc": "Nástroj pro rozřezání ploch sítě na menší části",
	"action.duplicate_project": "Duplikovat Projekt",
	"action.duplicate_project.desc": "Vytvoří kopii otevřeného projektu",
	"action.transform_space.parent": "Nadřazený",
	"action.transform_pivot_space": "Transformační prostor osy otáčení",
	"action.solidify_mesh_selection": "Upevnit plochy",
	"action.solidify_mesh_selection.desc": "Upevní vybrané plochy k síti",
	"action.animated_texture_editor": "Editor flipbooků...",
	"action.animated_texture_editor.desc": "Úprava animace flipbooku vybrané textury",
	"action.center_individual_pivots": "Centrovat jednotlivé osy otáčení",
	"action.center_individual_pivots.desc": "Nastavit bod otáčení všech vybraných prvků do jejich středu",
	"action.uv_cycle": "Procházet UV",
	"action.uv_cycle.desc": "Prochází pořadí UV vrcholů, aniž by měnil jejich pozice",
	"action.uv_cycle_invert": "Prohodit Pořadí UV",
	"action.uv_cycle_invert.desc": "Obrácení pořadí vrcholů UV bez změny pozic UV",
	"action.slider_animation_controller_speed": "Rychlost Přehrávání Ovladače",
	"action.slider_animation_controller_speed.desc": "Rychlost přehrávání animačních ovladačů v procentech",
	"action.optimize_animation": "Optimalizovat Animaci",
	"action.optimize_animation.desc": "Optimalizuje současnou animaci a zredukuje počet klíčových snímků",
	"action.change_animation_speed": "Změnit Rychlost Animace...",
	"action.change_animation_speed.desc": "Změní rychlost vybrané animace",
	"timeline.select_particle_file": "Vybrat Texturu Částic",
	"timeline.select_sound_file": "Vybrat Zvukový Soubor",
	"menu.cube.texture.default": "Výchozí",
	"menu.texture.particle.clear": "Přestat používat pro Částice",
	"menu.texture.use_as_default": "Nastavit jako Výchozí",
	"menu.texture.use_as_default.clear": "Zrušit nastavení jako Výchozí",
	"menu.toolbar.overflow": "Přesah panelu nástrojů",
	"edit.solidify_mesh_selection.thickness": "Tloušťka",
	"reference_image.sync_to_timeline": "Synchronizovat s Čas. Osou",
	"reference_image.toggle_playback": "Přehrát/Pozastavit",
	"dialog.add_primitive.shape.beveled_cuboid": "Zaoblený Kvádr",
	"dialog.ignore_all": "Ignorovat Vše",
	"data.texture_group": "Skupina Textur",
	"data.animation": "Animace",
	"generic.on": "Zapnuto",
	"generic.off": "Vypnuto",
	"format.free.info.3d_printing": "3D Tisk",
	"message.invalid_file.merge_conflict": "Soubor obsahuje nevyřešené konflikty při sloučení Git.",
	"dialog.expand_texture_selection.radius": "Množství",
	"dialog.expand_texture_selection.corner": "Tvar Rohu",
	"dialog.expand_texture_selection.corner.round": "Zaoblený",
	"dialog.expand_texture_selection.corner.square": "Čtvercový",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Sloučit do",
	"keybindings.variation_conflict": "Varianta je v konfliktu s hlavní klávesovou zkratkou",
	"settings.recovery_save_interval": "Interval ukládání bodu obnovení",
	"settings.recovery_save_interval.desc": "Blockbench pravidelně ukládá otevřený projekt na pozadí pro případ vypnutí PC. Nastavte interval v sekundách. Nastavte na 0 pro vypnutí ukládání.",
	"settings.save_view_per_tab": "Uložit Zobrazení pro každou Kartu",
	"settings.save_view_per_tab.desc": "Uložit aktuální úhel pohledu pro každou kartu zvlášť",
	"settings.inherit_parent_color": "Převzít Barvu Nadřazeného",
	"settings.inherit_parent_color.desc": "Nastaví barvu značky nově vytvořeného prvku na barvu nadřazeného místo náhodné barvy",
	"keybind.preview_select.multi_select": "Vícenásobný-výběr",
	"keybind.preview_select.group_select": "Skupinový-výběr",
	"keybind.preview_select.loop_select": "Cyklický-výběr",
	"action.fill_mode.selection": "Výběr",
	"action.fill_mode.selected_elements": "Vybrané Prvky",
	"action.image_tiled_view": "Zobrazení dlaždic",
	"action.image_tiled_view.description": "Povolit zobrazení dlaždic ve 2D editoru",
	"action.image_onion_skin_view": "Obrázkový edit cibulového vrstvení",
	"action.image_onion_skin_view.description": "Povolí zobrazení cibulového vrstvení v 2D editoru",
	"action.expand_texture_selection": "Rozšířit výběr textury",
	"action.expand_texture_selection.desc": "Rozšíří nebo zmenší výběr textury",
	"action.switch_tabs.reverse_order": "Obrátit pořadí",
	"action.save_project_incremental": "Uložit novou verzi",
	"action.save_project_incremental.desc": "Uloží aktuální model jako soubor projektu s novou verzí (např.: project_2.bbmodel)",
	"action.copy.multiple": "Kopírovat Vše",
	"action.copy.multiple.desc": "Kopíruje všechna dostupná data jednotlivě",
	"action.paste.multiple": "Vložit Vše",
	"action.randomize_marker_colors": "Náhodně uspořádat barvy značek",
	"action.cube_light_emission": "Emise Světla",
	"action.cube_light_emission.desc": "Změňte emisivitu vybraných kostek na hodnotu mezi 0 a 15",
	"action.view_mode.colored_solid": "Plné s barvami fixů",
	"action.focus_on_selection.rotate_only": "Pouze otočit",
	"action.create_texture_group": "Vytvořit Skupinu Textur",
	"action.create_texture_group.desc": "Vytvořte skupinu pro své textury",
	"action.uv_maximize.all_faces": "Ovlivnit všechny plochy",
	"action.retarget_animators": "Přemapovat Animace",
	"action.retarget_animators.desc": "Vyberte, který animátor cílí na kterou část těla nebo prvek",
	"action.merge_animation": "Sloučit Animaci",
	"action.merge_animation.desc": "Sloučí animaci do jiné animace",
	"action.add_keyframe.reset_values": "S výchozími hodnotami",
	"action.set_timeline_range_start": "Nastavit Začátek Časové Osy",
	"action.set_timeline_range_start.desc": "Nastavte počáteční bod pro vlastní rozsah přehrávání na časové ose animace",
	"action.set_timeline_range_end": "Nastavit Konec Časové Osy",
	"action.set_timeline_range_end.desc": "Nastavení koncového bodu pro vlastní rozsah přehrávání na časové ose animace",
	"action.disable_timeline_range": "Zakázat rozsah časové osy",
	"action.disable_timeline_range.desc": "Zakáže vlastní rozsah přehrávání na časové ose animace",
	"menu.texture_group.resolve": "Vyřešit",
	"menu.image_tiled_view.mirrored": "Zrcadlové hrany",
	"menu.image_onion_skin_view.frame": "Snímky",
	"menu.image_onion_skin_view.frame.last_viewed": "Poslední Zobrazený Snímek",
	"menu.image_onion_skin_view.frame.previous": "Předchozí Snímek",
	"menu.image_onion_skin_view.frame.next": "Další Snímek",
	"menu.image_onion_skin_view.frame.both": "Predchozí + Další",
	"menu.image_onion_skin_view.display": "Zobrazení",
	"menu.image_onion_skin_view.display.pixels": "Menší pixely",
	"menu.image_onion_skin_view.display.transparent": "Průhledný",
	"menu.image_onion_skin_view.above": "Zobrazit výše",
	"menu.animation.reload": "Znovu načíst",
	"switches.autouv.alt": "Relativní",
	"display.rotation_pivot": "Rotace osy otáčení",
	"display.scale_pivot": "Měřítko osy otáčení",
	"display.reference.fox": "Liška",
	"display.reference.eating": "Jí",
	"preview_scene.sky": "Obloha",
	"preview_scene.space": "Vesmír",
	"preview_scene.minecraft_ocean": "Oceán",
	"message.import_palette.selection_only": "Pouze výběr",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generovat...",
	"dialog.blend_transition_edit.generate.learn_more": "Více informací a náhled",
	"dialog.blend_transition_edit.generate.curve": "Typ časování",
	"dialog.blend_transition_edit.generate.steps": "Klíčové snímky",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Omezí počet snímků za sekundu, které Blockbench vykreslí. Skutečná snímková frekvence je omezena tím, co vaše zařízení dokáže zobrazit.",
	"settings.outliner_reveal_on_select": "Zobrazit prvky při výběru",
	"settings.outliner_reveal_on_select.desc": "Zobrazí prvky v osnově, pokud jsou vybrány",
	"settings.java_export_pivots": "Export otočných os v blokových/předmětových modelech Java",
	"settings.java_export_pivots.desc": "Uloží otočné body v blokových/předmětových modelech Java na kostkách bez rotace",
	"animation_controllers.state.blend_transition_curve": "Křivka přechodu prolnutí",
	"menu.slider.reset_vector": "Resetovat vektor",
	"dialog.blend_transition_edit.extended": "Rozšířený graf",
	"message.screenshot_too_large.title": "Problém s rozlišením obrazovky",
	"message.screenshot_too_large.message": "Snímek obrazovky se nepodařilo úspěšně vykreslit. Zkuste to prosím znovu s nižším rozlišením nebo bez supersamplingu.",
	"message.rename_elements.numbering": "Pro generování pořadových čísel můžete použít speciální znaky: % pro získání indexu prvku v jeho skupině, $ pro získání indexu v rámci výběru.",
	"generic.edit_externally": "Upravit Externě",
	"message.settings_require_restart.title": "Vyžaduje Restart",
	"message.settings_require_restart.message": "Některá nastavení se projeví až po restartu programu.",
	"message.settings_require_restart.restart_now": "Restartovat Nyní",
	"message.settings_require_restart.restart_later": "Restartovat Později",
	"message.classroom_mode.install_plugin": "Nelze instalovat pluginy v režimu Učebny",
	"dialog.collection.export_path": "Cesta Exportu",
	"dialog.collection.select_all": "Vybrat Vše",
	"dialog.collection.select_none": "Nevybrat Žádné",
	"dialog.collection.add_with_filter": "Přidat s Filtrem",
	"dialog.collection.remove": "Odstranit",
	"dialog.material_config.title": "Nastavení Materiálu",
	"dialog.material_config.color_value": "Hodnota Barvy",
	"dialog.material_config.mer": "Emisivní drsnost kovu",
	"dialog.material_config.mer_value": "Hodnota MER",
	"dialog.material_config.depth_type": "Typ hloubky",
	"dialog.create_texture.disable_mirror_uv": "Zakázat Zrcadlení UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Zakáže možnost UV zrcadlení v části Zrcadlové modelování pro zachování samostatné UV pro každou stranu modelu",
	"dialog.create_gif.turn.sync_to_anim_length": "Synchronizace s délkou animace",
	"settings.category.controls": "Ovládání",
	"settings.classroom_mode": "Režim Učebny",
	"settings.classroom_mode.desc": "Omezuje některé funkce, například instalaci pluginů, skrývá odkazy na sociální sítě",
	"settings.antialiasing_bleed_fix": "Opravit prosakování vyhlazování hran",
	"settings.antialiasing_bleed_fix.desc": "Opraví krvácení textur při použití anti-aliasingu. Potenciálně nepodporováno na starším hardwaru.",
	"settings.tone_mapping": "Mapování Tónů",
	"settings.tone_mapping.desc": "Metoda aproximace pro zobrazení vysokého dynamického rozsahu na standardní obrazovce pro PBR rendering.",
	"settings.audio_scrubbing": "Zvuk pro procházení časové osy",
	"settings.audio_scrubbing.desc": "Přehraje krátké ukázky zvuku při procházení časové osy",
	"settings.viewport_rotate_speed": "Rychlost otáčení zobrazení",
	"settings.viewport_rotate_speed.desc": "Citlivost vstupu při otáčení v zobrazení",
	"settings.viewport_zoom_speed": "Rychlost přibližování zobrazení",
	"settings.viewport_zoom_speed.desc": "Citlivost vstupu při přiblížení v zobrazení",
	"settings.editor_2d_zoom_speed": "Rychlost Přiblížení 2D Editoru",
	"settings.editor_2d_zoom_speed.desc": "Citlivost vstupu při přibližování v UV a 2D editoru malování",
	"category.select": "Výběr",
	"action.vertex_snap_mode.rotate": "Otočit",
	"action.export_image": "Exportovat Obrázek",
	"action.export_image.desc": "Exportujte svou texturu jako obrazový soubor",
	"action.apply_mirror_modeling": "Použít zrcadlové modelování",
	"action.apply_mirror_modeling.desc": "Použije zrcadlové modelování na výběr. Všechny vybrané prvky budou zkopírovány a otočeny přes osu X.",
	"action.create_collection": "Vytvořit Kolekci",
	"action.create_collection.desc": "Vytvoří kolekci z výběru v outlineru",
	"action.set_collection_content_to_selection": "Nastavit Obsah Kolekce Podle Výběru",
	"action.set_collection_content_to_selection.desc": "Nastaví vybrané skupiny a prvky jako obsah kolekce",
	"action.add_to_collection": "Přidat vybrané do kolekce",
	"action.add_to_collection.desc": "Přídá vybrané skupiny a prvky do kolekce",
	"action.view_mode.material": "Náhled Materiálu",
	"action.create_material": "Vytvořit Materiál",
	"action.create_material.desc": "Vytvořit nový PBR materiál z vybrané textury",
	"action.generate_pbr_map": "Generovat PBR Mapu...",
	"action.generate_pbr_map.desc": "Vygenerovat PBR mapu (Výšková mapa nebo metalnost, emisivita, drsnost) z existující textury",
	"menu.tools.main_tools": "Nástroje",
	"menu.view.panels": "Panely",
	"menu.texture.pbr_channel": "PBR Kanál",
	"menu.texture.pbr_channel.color": "Barva",
	"menu.texture.pbr_channel.normal": "Normála",
	"menu.texture.pbr_channel.height": "Výška",
	"menu.texture.pbr_channel.mer": "MER (Metalnost-Emisivita-Drsnost)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Podpovrchový",
	"menu.collection.export_project": "Exportovat Projekt",
	"menu.collection.export_as": "Exportovat jako \"%0\"",
	"menu.panel.enable": "Povolit",
	"menu.panel.move_to": "Přesunout Do",
	"menu.panel.move_to.left_bar": "Levý Panel",
	"menu.panel.move_to.right_bar": "Pravý Panel",
	"menu.panel.move_to.top": "Nahoře",
	"menu.panel.move_to.bottom": "Dole",
	"menu.panel.move_to.float": "Plovoucí",
	"menu.panel.move_to.hidden": "Skrýt",
	"menu.panel.fold": "Sbalit",
	"menu.mirror_painting.texture_center": "Střed",
	"menu.mirror_modeling.mirror_uv": "Zrcadlit UV",
	"menu.animation_onion_skin.frames": "Snímky",
	"menu.animation_onion_skin.select": "Vybrat",
	"menu.animation_onion_skin.previous": "Předchozí",
	"menu.animation_onion_skin.next": "Další",
	"menu.animation_onion_skin.previous_next": "Předchozí + Další",
	"menu.animation_onion_skin.count": "Počet",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selektivní cibulové vrstvy",
	"menu.animation_onion_skin_selective.desc": "Zobrazí cibulové vrstvy pouze pro vybranou část modelu",
	"edit.loop_cut.unit": "Jednotka",
	"edit.loop_cut.unit.size_units": "Jednotky Velikosti",
	"edit.loop_cut.unit.percent": "Procento",
	"edit.extrude_mesh_selection.direction": "Směr",
	"edit.extrude_mesh_selection.direction.outwards": "Směrem ven",
	"edit.extrude_mesh_selection.direction.average": "Průměr",
	"edit.extrude_mesh_selection.even_extend": "Rovnoměrné rozšíření",
	"edit.vertex_snap.align": "Zarovnat",
	"edit.vertex_snap.align.longest": "Nejdelší Osa",
	"edit.vertex_snap.align.direction": "Směr od osy otáčení",
	"edit.vertex_snap.align.align_axis": "Osa %0",
	"edit.vertex_snap.ignore_axis": "Ignorovat Osu",
	"codec.common.format": "Formát",
	"codec.image.quality": "Kvalita",
	"panel.collections": "Kolekce",
	"modifier_actions.always": "Vždy Povoleno",
	"modifier_actions.unless": "Kromě %0",
	"settings.undo_selections": "Vrátit Výběr",
	"settings.undo_selections.desc": "Sledovat změny výběru jako krok v historii",
	"action.focus_on_selection.zoom": "Přizpůsobit oknu",
	"display.reference.tooting": "Troubení na Roh",
	"settings.selection_tolerance": "Tolerance Výběru",
	"settings.selection_tolerance.desc": "Velikost oblasti, na kterou lze kliknout pro výběr hrany nebo vrcholu",
	"action.delete.keep_vertices": "Ponechat hrany/vrcholy",
	"menu.mesh": "Síť",
	"dialog.material_config.subsurface": "Podpovrchové Rozptylování",
	"dialog.material_config.subsurface_enabled.desc": "Použít alfa kanál MER mapy pro podpovrchové rozptylování",
	"settings.pick_combined_color": "Vybrat Kombinovanou Barvu",
	"settings.pick_combined_color.desc": "Vybrat kombinovanou barvu všech vrstev na daném pixelu místo barvy na aktivní vrstvě",
	"action.split_rgb_into_layers": "Rozdělit RGB kanály do Vrstev",
	"action.split_rgb_into_layers.desc": "Rozdělit texturu do přídavných vrstev, jednu pro každý RGB kanál",
	"dialog.project.java_block_version": "Verze Formátu",
	"data.spline_mesh": "Křivka",
	"data.billboard": "Orientovaný Panel",
	"data.armature": "Kostra",
	"data.armature_bone": "Armatura části těla",
	"generic.reload": "Znovunačíst",
	"modifier_actions.subtract": "Odečíst",
	"modifier_actions.reduced_intensity": "Jemné Doladění",
	"modifier_actions.select_bone": "Vybrat Kost",
	"modifier_actions.spline_select_multiple_points": "Vybrat více Bodů nebo Úchytů",
	"modifier_actions.move_panel_without_docking": "Přesun bez dokování",
	"message.save_all_textures.message": "Chcete uložit každou z následujících textur?",
	"message.save_all_textures.skip": "Přeskočit",
	"dialog.add_spline.shape": "Tvar",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Obdélník",
	"dialog.add_spline.shape.circle": "Kruh",
	"dialog.add_spline.diameter": "Průměr",
	"dialog.add_spline.sides_tubular": "Dělení tubusu",
	"dialog.add_spline.sides_radial": "Dělení kruhu",
	"dialog.add_spline.radius": "Šířka tubusu",
	"dialog.add_spline.length": "Délka",
	"dialog.add_spline.width": "Šířka",
	"dialog.plugins.revoke_permissions": "Odvolat Oprávnění",
	"dialog.expression_editor.pretty_print": "Uspořádání řádků",
	"dialog.expression_editor.minify": "Minimalizovat",
	"dialog.expression_editor.find_replace": "Najít/Nahradit",
	"dialog.create_gif.show_gizmos": "Nahrávání Gizmos a mřížky",
	"dialog.preview_options.title": "Možnosti Náhledu",
	"dialog.preview_options.background": "Pozadí",
	"dialog.preview_options.background.checkerboard": "Šachovnice",
	"dialog.preview_options.background.solid": "Pevný",
	"dialog.preview_options.background.custom_color": "Vlastní Barva",
	"dialog.preview_options.show_gizmos": "Zobrazit manipulátory",
	"dialog.skin.texture_source": "Zdroj Textury",
	"dialog.skin.texture_source.template": "Vygenerovat Šablonu",
	"dialog.skin.texture_source.load_texture": "Načíst z Minecraftu",
	"dialog.skin.texture_file": "Soubor Textury",
	"dialog.convert_skin.adjust_texture": "Upravit Texturu",
	"dialog.settings.clear_profile_value": "Vymazat hodnotu profilu",
	"layout.section.customize": "Přizpůsobit",
	"layout.theme.configure": "Nastavit",
	"layout.color.elevated": "Vystouplé",
	"layout.color.elevated.desc": "Vystouplé prvky rozhraní, obvykle oddělené stínem",
	"layout.file.watch_changes": "Sledovat Změny a Načíst Znovu",
	"settings.autocomplete_code": "Automatické Doplňování Kódu",
	"settings.autocomplete_code.desc": "Návrhy doplňování v editoru kódu",
	"settings.detect_flipbook_textures": "Detekovat Flipbook Textury",
	"settings.detect_flipbook_textures.desc": "Automaticky detekuje animované textury Flipbooku a jejich náhled jako animace",
	"settings.double_click_select_reference": "Vybrat referenční obrázek dvojitým klikem",
	"settings.double_click_select_reference.desc": "Dvojitým klikem na zobrazení vyberete referenční obrázek",
	"settings.default_keyframe_interpolation": "Výchozí interpolace klíčových snímků",
	"settings.default_keyframe_interpolation.desc": "Vybere výchozí režim interpolace klíčových snímků",
	"settings.color_picker_style": "Styl výběru barev",
	"settings.color_picker_style.desc": "Vybere styl výběru barvy v režimu malování",
	"settings.export_asset_paths": "Exportní cesty k datovým zdrojům",
	"settings.export_asset_paths.desc": "Vybere, jak se cesty k datovým zdrojům, jako jsou textury nebo animace, ukládají do souborů .bbmodel",
	"settings.export_asset_paths.relative": "Relativní Cesty",
	"settings.export_asset_paths.absolute": "Úplné Cesty",
	"settings.export_asset_paths.both": "Relativní a Úplné Cesty (Pouze Textury)",
	"settings.export_asset_paths.none": "Žádný Export",
	"action.slider_spline_resolution": "Rozlišení Křivky %0",
	"action.slider_spline_resolution.desc": "Změniz rozlišení křivky na ose %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Dělení kruhu",
	"action.slider_spline_resolution.v.desc_precision": "Dělení tubusu",
	"action.slider_spline_radius": "Poloměr Kŕivky",
	"action.slider_spline_radius.desc": "Změnit poloměr křivky",
	"action.slider_spline_handle_tilt": "Náklon Úchytu",
	"action.slider_spline_handle_tilt.desc": "Změnit náklon úchytu křivky",
	"action.slider_spline_handle_size": "Velikost Úchytu",
	"action.slider_spline_handle_size.desc": "Změnit velikost úchytu křivky",
	"action.blend_mode.lighten": "Zesvětlit",
	"action.blend_mode.darken": "Ztmavit",
	"action.weight_brush": "Štětec vah",
	"action.weight_brush.desc": "Malovat váhy vrcholů na síťových modelech pro armaturové deformace",
	"action.convert_minecraft_skin_variant": "Převést Úzký/Široký Skin",
	"action.convert_minecraft_skin_variant.desc": "Přepíná model postavy mezi klasickým širokým tělem (Steve) a štíhlejším tělem (Alex). Volitelně automaticky upraví texturu, aby přesně seděla na nový model.",
	"action.custom_skin_poses": "Vlastní Pózy Skinu",
	"action.custom_skin_poses.desc": "Načíst vlastní přednastavenou pózu skinu",
	"action.custom_skin_poses.update": "Aktualizovat Pózu",
	"action.custom_skin_poses.update.desc": "Přepsat uloženou pózu aktuální pózou modelu",
	"action.add_custom_skin_pose": "Přidat vlastní pózu skinu",
	"action.add_custom_skin_pose.desc": "Uloží aktuální polohu modelu jako přednastavenou polohu",
	"action.export_stl": "Exportovat STL",
	"action.export_stl.desc": "Exportovat STL model pro 3D tisk",
	"action.add_element": "Přidat Prvek",
	"action.add_element.desc": "Přidat nový prvek ze seznamu typů prvků",
	"action.add_spline": "Přidat Křivku",
	"action.add_spline.desc": "Přidá novou křivku",
	"action.add_billboard": "Přidat Orientovaný Panel",
	"action.add_billboard.desc": "Přidá nový orientovaný panel, plochý prvek, který se vždy otáčí směrem ke kameře",
	"action.add_armature": "Přidat armaturu",
	"action.add_armature.desc": "Přidá armaturu, která umožňuje deformovat síť pomocí animace",
	"action.add_armature_bone": "Přidat armaturu části těla",
	"action.add_armature_bone.desc": "Přidá kost do kostry",
	"action.search_textures": "Hledat Textury",
	"action.search_textures.desc": "Hledat textury podle názvu",
	"action.search_animations": "Hledat Animace",
	"action.search_animations.desc": "Hledat animace podle názvu",
	"action.spline_selection_mode": "Režim Výběru Křivky",
	"action.spline_selection_mode.object": "Objekt",
	"action.spline_selection_mode.handles": "Úchyty",
	"action.spline_render_mode": "Geometrie",
	"action.spline_render_mode.mesh": "Síť",
	"action.spline_render_mode.path": "Cesta",
	"action.spline_render_mode.desc": "Jakou geometrii má tato křivka vykreslit",
	"action.spline_uv_mode": "Styl UV",
	"action.spline_uv_mode.length_accurate": "Přesná Délka",
	"action.spline_uv_mode.uniform": "Jednotný",
	"action.spline_uv_mode.per_segment": "Na Segment",
	"action.spline_uv_mode.desc": "Jak by měl tubus ze křivky sítě rozmístit své UV mapy",
	"action.spline_ring_segments": "Dělení kruhu",
	"action.spline_ring_segments.desc": "Počet dělení této křivky na každý kruh tubusu",
	"action.spline_tube_segments": "Dělení tubusu",
	"action.spline_tube_segments.desc": "Počet dělení této křivky podél její dráhy",
	"action.spline_tube_radius": "Poloměr tubusu",
	"action.spline_tube_radius.desc": "Nastavit poloměr tubusu křivky",
	"action.spline_display_space": "Zobrazit prostor",
	"action.spline_display_space.desc": "Zobrazí značky prostoru podél křivky",
	"action.spline_handle_mode": "Režim úchytů křivky",
	"action.spline_handle_mode.desc": "Který režim použít pro transformaci úchytů křivky",
	"action.spline_handle_mode.aligned": "Zarovnaný",
	"action.spline_handle_mode.free": "Volně",
	"action.spline_handle_mode.mirrored": "Zrcadlené",
	"action.slider_weight_brush_size": "Velikost štětce vah",
	"action.weight_brush_xray": "Režim X-Ray štětce vah",
	"action.weight_brush_xray.desc": "Pokud je povoleno, váhový štětec ovlivní všechny vrcholy, ne pouze ty, které jsou viditelné na povrchu",
	"action.apply_spline_rotation": "Použít Rotaci",
	"action.apply_spline_rotation.desc": "Resetovat rotaci prvku křivky a aplikovat ji na geometrii",
	"action.extrude_spline_selection": "Extrudovat Křivku",
	"action.extrude_spline_selection.desc": "Extrudovat vybraný úchyt na všech křivkách",
	"action.split_spline": "Rozdělit křivku",
	"action.split_spline.desc": "Rozdělí křivku na dvě samostatné křivky v místě vybraného úchytu",
	"action.divide_spline_curve": "Rozdělit Segment Křivky",
	"action.divide_spline_curve.desc": "Rozdělí segment křivky na dva nové segmenty s novým úchytem v místě rozdělení",
	"action.set_vertex_weights": "Nastavit váhy vrcholů",
	"action.set_vertex_weights.desc": "Nastaví váhy vybraných vrcholů na zvolenou hodnotu u konkrétní části těla",
	"action.calculate_vertex_weights": "Vypočítat váhy vrcholů",
	"action.calculate_vertex_weights.desc": "Automaticky přiřadit váhy vrcholů podle pozice části těla",
	"action.shelf_alignment": "Zarovnání Poličky",
	"action.shelf_alignment.desc": "Vybere svislé zarovnání položek na poličce",
	"action.shelf_alignment.top": "Zarovnání Nahoře",
	"action.shelf_alignment.bottom": "Zarovnání Dole",
	"action.view_mode.vertex_weight": "Váha Vrcholu",
	"action.view_mode.weighted_bone_colors": "Barvy vrcholů části těla",
	"action.create_animation_group": "Vytvořit Skupinu Animací",
	"action.create_animation_group.desc": "Vytvořit skupinu animací",
	"action.move_graph_keyframes_up": "Posunout graf klíčových snímků nahoru",
	"action.move_graph_keyframes_down": "Posunout graf klíčových snímků dolů",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Editor Výrazů",
	"menu.color_picker.picker_type.normal": "Normálová Mapa",
	"menu.texture.flipbook_animation": "Flipbook Animace",
	"menu.panel.attach_to": "Připojit k",
	"menu.animation.playing": "Přehrává Se",
	"menu.animation_file.save_as": "Uložit Jako",
	"menu.animator.quaternion_interpolation": "Interpolace Kvaternionů",
	"edit.extrude_spline_selection.extend": "Prodloužit",
	"edit.divide_spline_curve.position": "Pozice",
	"group.bedrock_binding": "Vazba",
	"group.cem_attach": "Připojení CEM",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "Měřítko CEM",
	"cube.rescale": "Přepočítat měřítko rotace",
	"cube.rescale.desc": "Prepočíta velikost krychle tak, aby kompenzovala úhel rotace",
	"mesh.shading": "Stínování",
	"mesh.shading.flat": "Ploché",
	"mesh.shading.smooth": "Hladké",
	"spline_mesh.cyclic": "Cyklický",
	"spline_mesh.cyclic.desc": "Pokud by vybraná křivka měla tvořit smyčku",
	"billboard.offset": "Posun",
	"billboard.facing_mode": "Režim Orientace",
	"billboard.facing_mode.lookat": "Sledovat Cíl",
	"billboard.facing_mode.lookat_y": "Sledovat Y",
	"billboard.facing_mode.rotate": "Otočit",
	"billboard.facing_mode.rotate_y": "Otočit Y",
	"armature_bone.connected": "Propojeno",
	"reference_image.blueprint": "Uzamčený Plán",
	"codec.image.alpha_channel": "Alfa Kanál",
	"codec.image.animation_fps": "FPS Animace",
	"panel.palette": "Paleta",
	"panel.keyframe.change_effect_file": "Změnit soubor efektů",
	"panel.transform": "Transformace",
	"panel.element.spline_dimensions": "Rozměry křivky",
	"display.slot.on_shelf": "Polička",
	"display.reference.shelf": "Polička (Všechny Sloty)",
	"display.reference.shelf_left": "Polička (Levý Slot)",
	"display.reference.shelf_center": "Polička (Střední Slot)",
	"display.reference.shelf_right": "Polička (Pravý Slot)",
	"message.newer_project_format_version.title": "Zastaralý Klient",
	"message.newer_project_format_version.message": "Tento soubor byl uložen ve novější verzi Blockbench. Aktualizujte na Blockbench %0 nebo novější, abyste jej mohli správně otevřít",
	"message.load_images.add_layer": "Přidat jako Vrstvu",
	"message.load_images.category.add_to_project": "Přidat do projektu",
	"message.load_images.category.new_project": "Nový projekt",
	"message.load_palette.title": "Načíst Paletu",
	"message.load_palette.message": "Opravdu chcete načíst tuto paletu? Tím se nahradí vaše aktuální barevná paleta.",
	"dialog.set_vertex_weights.weight": "Závažnost",
	"dialog.set_vertex_weights.overwrite": "Přepsat ostatní části těla",
	"action.element_render_order.short": "Pořadí Vykreslování",
	"action.element_render_order.desc": "Pořadí vykreslování prvků. Toto může pomoci opravit prvky, které jsou skryté za průhlednými texturami. Nechte na Automaticky pro neprůhledné prvky.",
	"spline.shading.flat": "Ploché",
	"spline.shading.smooth": "Hladké",
	"spline.shading": "Stínování",
	"spline.shading.desc": "Jak by měl být tubus této křivky stínován",
	"action.slider_weight_brush_limit": "Limit štětce vah",
	"action.slider_weight_brush_limit.desc": "Nastaví horní limit, kolik váhy může štětec přiřadit k vrcholu",
	"action.weight_brush_blend_mode": "Režim prolnutí štětce vah",
	"action.weight_brush_blend_mode.set": "Nastavit",
	"action.weight_brush_blend_mode.add": "Přidat",
	"action.apply_texture_to_elements": "Aplikovat Texturu na Prvky",
	"action.apply_texture_to_elements.desc": "Použít vybranou texturu na vybrané prvky",
	"menu.panel.reset_size": "Resetovat Velikost",
	"action.import_layer": "Importovat Vrstvu",
	"action.import_layer.desc": "Importovat obrazové soubory jako vrstvy",
	"menu.collection.open_file": "Otevřít Soubor",
	"layout.version": "Verze",
	"settings.status_bar_transform_sliders": "Transformace posuvníků ve stavovém řádku",
	"settings.status_bar_transform_sliders.desc": "Zobrazit panel posuvníků transformace vybraného nástroje ve stavovém řádku místo použití panelu Transformace",
	"settings.default_bedrock_format": "Výchozí Bedrock Formát",
	"settings.default_bedrock_format.desc": "Vyberte výchozí formát pro načítání modelů Minecraft Bedrock, pokud nelze z kontextu zjistit konkrétní formát.",
	"settings.limit_brush_opacity_per_stroke": "Omezit Průhlednost Štětce na Jeden Tah",
	"settings.limit_brush_opacity_per_stroke.desc": "Omezit průhlednost, kterou může štětec aplikovat podle hodnoty posuvníku při každém tahu. U hladkého štětce může toto způsobit nežádoucí šum.",
	"action.merge_splines": "Sloučit křivky",
	"action.merge_splines.desc": "Sloučit více křivek do jedné",
	"settings.default_java_block_version": "Výchozí verze Java bloku / předmětu",
	"settings.default_java_block_version.desc": "Výchozí verze formátu při tvoření nového Java modelu nebo otevření souboru bez verze formátu",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}